/* ============================================================================
   ff-collector.js · the D&D Character Art collector page (templates/product.dnd-collector.json)
   Jan, 2026-10-20: the approved mock (docs/premium-plan-2026-10-19/product-page/, through round 7) made real.

   What this file owns: the collector gallery (painting, your signed Hall card, the certificate), the visual-only
   card customizer, "What you receive", the Hall card section, the collection (live from the Hall by slug through
   ffShowcase), the card viewer, "On your wall and at your table" (the wall photos, the tabletop game, the falling
   Hall wall), the Loox review row, and the small glue to the live buy box. Jan removed the closing "Save your
   character's spot" block in round 7, so the reviews follow the questions and the sticky bar stays up to the end.

   What it never touches: the waitlist form, the turn checkout, the size rows' own logic, the pixel, CAPI, Klaviyo,
   the Data Hub notes, the cart. Those stay in custom_liquid_gDWXDf, ff-turn-queue and the sticky bar, exactly as on
   the live page. This file only watches them:
   - the picture: the size rows and the turn checkout paint the chosen size into Dawn's first gallery slide (hidden
     here); a MutationObserver mirrors that picture into the collector gallery, the stack, the cards and the bar;
   - the size: the pressed row (#dds-sizes [aria-pressed=true]) names the size for the card's Size row, card colours
     and the certificate (each size has its own);
   - the turn: rows marked .ffq-turn-tier mean a turn is open (html.ffc-turn).

   The video game and story pages draw their cards here too (Jan, 2026-10-24: "the cards arent detailed enough, these
   should look the same as the dnd pages"). Their top section (ff-lane-main) hands over the same config with three more
   keys: yours (the words on the visitor's card and the rows on its back), rowArt (with no Dawn gallery to watch, the
   card takes the chosen row's own painting) and the gallery's card hosts ([data-ffc-mine]). The D&D page sets none of
   them and is drawn as before.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__ffCollector) return;
  window.__ffCollector = true;

  var D = document;
  var CFG = {};
  try { CFG = JSON.parse((D.getElementById('ffcConfig') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  CFG.variants = CFG.variants || [];
  CFG.paint = CFG.paint || [];
  CFG.certs = CFG.certs || [];

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var RMQ = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var FINE = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  function rm() { return RMQ.matches; }
  function onIdle(fn, t) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: t || 1200 }); else setTimeout(fn, 60); }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6 6.5.8-4.8 4.5 1.2 6.5L12 17.3l-5.8 3.1 1.2-6.5L2.6 9.4l6.5-.8z"/></svg>';

  /* ---------------- the card's palettes ---------------- */
  var FOUNDING = +CFG.foundingCap || 250;
  var YEAR = String(CFG.year || '2026');
  var COLOURS = [
    ['obsidian', 'Obsidian', '#15121a', '#0a0a0f'], ['violet', 'Violet', '#24133a', '#0e0718'], ['deepsea', 'Deep Sea', '#0b2430', '#050f15'],
    ['forest', 'Forest', '#10241a', '#06100b'], ['ember', 'Ember', '#2e1309', '#120704'], ['frost', 'Frost', '#1a2638', '#0b111b'],
    ['wine', 'Wine', '#2c0f1c', '#12060b'], ['parchment', 'Parchment', '#f1e7d2', '#dccfb3']
  ];
  var FRAMES = {
    gold: { n: 'Gold', line: '#c8a45e', type: '#c8a45e', light: '#f2d98e', deep: '#6a3f0c', name: '#fff5d8', hi: '#fff3cf', dk: '#7a5a22' },
    silver: { n: 'Silver', line: '#a9b0bc', type: '#b4bbc6', light: '#eef1f6', deep: '#3f4650', name: '#f7f9fc', hi: '#ffffff', dk: '#5d6470' },
    copper: { n: 'Copper', line: '#b87650', type: '#c88a63', light: '#f3b98f', deep: '#6d3c22', name: '#ffeadb', hi: '#ffe2cc', dk: '#6d3c22' }
  };
  var FINISHES = [['matte', 'Matte'], ['foil', 'Foil'], ['etched', 'Etched']];

  /* ---------------- state: the visitor's card and the chosen size ---------------- */
  var lead = +CFG.lead || 0;
  var S = {
    size: lead,
    art: (CFG.variants[lead] || {}).img || '',
    look: { colour: 'painting', frame: 'gold', finish: 'matte' }   /* the default: gold, matte, from the painting */
  };
  function sizeTitle(i) { return (CFG.variants[i] || {}).title || ''; }
  function widthUrl(u, w) {
    if (!u) return u;
    if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function resolveYourLook(l) {
    var g;
    if (l.colour === 'painting') g = CFG.paint[S.size] && CFG.paint[S.size][0] ? CFG.paint[S.size] : [COLOURS[0][2], COLOURS[0][3]];
    else { var c = COLOURS.filter(function (x) { return x[0] === l.colour; })[0] || COLOURS[0]; g = [c[2], c[3]]; }
    return { g1: g[0], g2: g[1], frame: l.frame, finish: l.finish, light: l.colour === 'parchment' };
  }
  function yours() {
    var Y = CFG.yours || {};
    return {
      key: 'yours', name: Y.name || 'Your hero', race: Y.race != null ? Y.race : 'Race', cls: Y.cls != null ? Y.cls : 'Class',
      ep: Y.ep || "Your character's title", img: widthUrl(S.art, 800), no: nextNo(),
      quote: Y.quote || 'The line your table knows them by.', qr: CFG.qrHall, fx: Y.fx,
      /* one date on the card (Jan, 2026-10-21: "we dont need first draft and finished, just have 1 date"); a lane page
         names its own rows instead (Game, Class ...), the size still last */
      ledger: (Y.rows && Y.rows.length ? Y.rows.slice() : [['Commissioned', dayFrom(0), dayShort(0)]]).concat([['Size', sizeTitle(S.size)]])
    };
  }

  /* ---------------- the numbers: No. X/250, the Founder's Edition (Jan, rounds 4, 6 and 7) ---------------- */
  function founding(h) { return !!(h.no && h.no <= FOUNDING); }
  /* The editions (Jan, 2026-10-21): No. 1 to 250 are the Founder's Edition, then every 50 numbers make the next edition,
     First (251 to 300) through Fifth (451 to 500). Every number past 500 is the Unlimited Edition, which has no cap, so
     its number reads alone ("No. 734", never "/1000"; Jan, 2026-10-21: "from 500 to 1000 make it unlimited edition"). */
  var EDITIONS = [[FOUNDING, 'Founder\u2019s Edition'], [300, 'First Edition'], [350, 'Second Edition'], [400, 'Third Edition'], [450, 'Fourth Edition'], [500, 'Fifth Edition'], [Infinity, 'Unlimited Edition']];
  function editionOf(n) { n = +n || 1; for (var i = 0; i < EDITIONS.length; i++) if (n <= EDITIONS[i][0]) return EDITIONS[i]; return null; }
  /* an edition's cap for "/250", or nothing for the Unlimited Edition */
  function capOf(e) { return e && e[0] < Infinity ? e[0] : 0; }
  /* the visitor's own card is filled in (Jan, 2026-10-21): the next number in the Hall and the dates if they ordered today */
  function nextNo() { var n = $('[data-ffc-latest]'); return n ? (+n.getAttribute('data-ffc-latest') || 0) + 1 || null : null; }
  function dayShort(add) { var d = new Date(); d.setDate(d.getDate() + add); try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } }
  function dayFrom(add) { var d = new Date(); d.setDate(d.getDate() + add); try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return d.toDateString().slice(4); } }
  /* The number line on the card front, and the word beside it. */
  function numberHTML(h) {
    if (!h.no) return '<span class="cf-no">No.<i class="cf-blank"></i></span>';
    var f = founding(h), e = editionOf(h.no);
    return '<span class="cf-no ' + (f ? 'cf-gold' : 'cf-fl') + '">No. ' + h.no + (capOf(e) ? '/' + capOf(e) : '') + '</span>';
  }
  /* Every card reads "Founder’s Edition" (Jan, round 7): the visitor's own card, the reserved card and every numbered
     card. The one exception keeps the words honest later on: a card numbered past the cap reads "1 of 1". */
  function editionText(h) { var e = editionOf(h.no); return e ? e[1] : ''; }
  /* The number on the card back and the line under it. "No. 134" is centred on the card and its "/250" sits beside it:
     an unseen copy of the "/250" on the left (.cf-bk-cap0) balances the line (Jan, 2026-10-23: "The card No. is left
     aligned not centered"). Both copies grow or step aside together in the legibility pass. */
  function backNumberHTML(h) {
    var f = founding(h), e = editionOf(h.no), cap = h.no && capOf(e) ? '/' + capOf(e) : '';
    return '<div class="cf-bk-no ' + (f ? 'cf-gold' : 'cf-fl') + '">' + (cap ? '<small class="cf-bk-cap0" aria-hidden="true">' + cap + '</small>' : '') +
      'No.' + (h.no ? ' ' + h.no + (cap ? '<small>' + cap + '</small>' : '') : '<i></i>') + '</div>' +
      '<div class="cf-bk-sub">' + editionText(h) + '</div>';
  }

  /* ---------------- Jan's signature, traced the way the pen moves (Jan, rounds 4 to 9) ----------------
     Left to right like cursive, in five smooth pen strokes: 1) up the left stroke of the J to its top tip, 2) down the
     right stroke to the waist, 3) down the tail's outer side to its bottom tip, 4) back up the tail's inner side,
     5) over the tie at the line and out through the little hook on the right. Her real scan
     (assets/ff-collector-signature.png, never redrawn) is a fixed mask and the strokes only uncover it.
     The pen keeps a handwriting rhythm (round 9): slower in the curves and the turns, faster on the straight runs.
     SIG_P holds each stroke [path, width], SIG_R where each stroke sits along the pen's whole path [start, length],
     and SIG_TT the pen's distance at even moments across SIG_T seconds. sigPlay() reads SIG_TT every frame and uncovers
     each stroke up to the pen; no CSS transition is involved. The numbers come from the approved mock, which rebuilds
     them with docs/prototypes/signed-and-numbered/signature/trace-timing.py; copy them from there, never by hand.
     [data-rv=0] on the card or certificate hides the ink, [data-rv=1] is the signing, and with neither the full scan shows.
     The pen runs SIG_T, 0.62 s (Jan, 2026-10-24: "the signature is signining too slowly, so make it faster and smoother"),
     and when it lifts the scan simply takes over: the strokes uncover every bit of it, and the old soft hand-off, the scan
     fading in over the strokes (data-rv 2), doubled the ink's soft edges, so it flashed bold and thinned again ("not smooth
     and its jagged and gltichy"). Only the strokes still moving are touched each frame.
     The mask is CSS (ff-collector.css .ffc-sig, -webkit-mask for WebKit) rather than an SVG <mask><image>: Chrome
     counts an SVG <image> as a Largest Contentful Paint candidate, and the signatures would have become the page's
     LCP seconds after the painting. A CSS mask image never is. Each SVG still gets its own id. */
  var SIG_N = 0;
  var SIG_P = [
    ['M174.0 354.0C174.4 353.0 175.7 351.0 176.5 348.0C177.3 345.0 177.8 340.0 179.0 336.0C180.2 332.0 181.9 328.0 183.9 324.0C185.9 320.0 188.5 316.0 191.1 312.0C193.7 308.0 196.6 304.0 199.3 300.0C202.0 296.0 204.7 292.0 207.5 288.0C210.3 284.0 213.2 280.0 216.1 276.0C219.0 272.0 221.8 268.0 224.7 264.0C227.6 260.0 230.4 256.0 233.3 252.0C236.2 248.0 239.2 244.0 242.3 240.0C245.4 236.0 248.5 232.0 251.7 228.0C254.9 224.0 258.1 220.0 261.3 216.0C264.6 212.0 267.9 208.0 271.2 204.0C274.5 200.0 277.8 196.0 281.1 192.0C284.4 188.0 287.8 184.0 291.1 180.0C294.4 176.0 297.5 172.0 300.9 168.0C304.3 164.0 307.8 160.0 311.3 156.0C314.8 152.0 318.4 148.0 321.8 144.0C325.2 140.0 328.3 136.0 331.8 132.0C335.3 128.0 339.1 124.0 342.8 120.0C346.5 116.0 350.4 112.0 354.1 108.0C357.8 104.0 361.1 100.0 364.8 96.0C368.5 92.0 372.4 88.0 376.2 84.0C380.0 80.0 383.7 76.0 387.6 72.0C391.5 68.0 395.5 64.0 399.5 60.0C403.5 56.0 407.6 52.0 411.8 48.0C416.0 44.0 421.8 39.3 424.6 36.0C427.4 32.7 426.1 30.7 428.8 28.0C431.6 25.3 438.0 22.2 441.0 20.0C444.0 17.8 445.3 16.3 447.0 15.0C448.7 13.7 450.3 12.5 451.0 12.0', 22],
    ['M451.0 12.0C451.7 13.0 455.4 13.3 455.0 18.0C454.6 22.7 450.4 34.3 448.3 40.0C446.2 45.7 444.7 48.0 442.6 52.0C440.5 56.0 438.2 60.0 435.8 64.0C433.4 68.0 431.0 72.0 428.4 76.0C425.8 80.0 423.0 84.0 420.1 88.0C417.2 92.0 414.2 96.0 411.3 100.0C408.4 104.0 405.4 108.0 402.5 112.0C399.6 116.0 396.9 120.0 393.9 124.0C390.9 128.0 387.7 132.0 384.6 136.0C381.5 140.0 378.4 144.0 375.5 148.0C372.6 152.0 369.8 156.0 366.9 160.0C364.0 164.0 361.4 168.0 358.3 172.0C355.2 176.0 351.6 180.0 348.5 184.0C345.4 188.0 342.4 192.0 339.4 196.0C336.4 200.0 333.5 204.0 330.6 208.0C327.7 212.0 324.8 216.0 321.8 220.0C318.8 224.0 315.8 228.0 312.7 232.0C309.6 236.0 306.2 240.0 303.1 244.0C300.0 248.0 296.9 252.0 293.9 256.0C290.9 260.0 288.0 264.0 285.2 268.0C282.4 272.0 279.8 276.0 276.9 280.0C274.0 284.0 270.7 288.0 267.6 292.0C264.5 296.0 261.5 300.0 258.5 304.0C255.5 308.0 252.5 312.0 249.5 316.0C246.5 320.0 243.4 324.0 240.4 328.0C237.4 332.0 233.4 336.7 231.4 340.0C229.4 343.3 230.2 345.7 228.5 348.0C226.8 350.3 223.1 352.0 221.0 354.0C218.9 356.0 216.8 359.0 216.0 360.0', 22],
    ['M216.0 360.0C215.1 360.7 212.9 361.3 210.8 364.0C208.8 366.7 206.7 372.0 203.5 376.0C200.3 380.0 195.4 384.0 191.5 388.0C187.6 392.0 183.6 396.0 179.9 400.0C176.2 404.0 172.8 408.0 169.3 412.0C165.8 416.0 162.3 420.0 158.7 424.0C155.1 428.0 151.1 432.0 147.5 436.0C143.9 440.0 140.5 444.0 137.1 448.0C133.7 452.0 130.5 456.0 127.3 460.0C124.1 464.0 121.2 468.0 118.1 472.0C115.0 476.0 111.7 480.0 108.5 484.0C105.3 488.0 102.2 492.0 99.1 496.0C96.0 500.0 93.1 504.0 90.1 508.0C87.1 512.0 84.0 516.0 81.0 520.0C78.0 524.0 74.9 528.0 71.9 532.0C68.9 536.0 65.9 540.0 63.2 544.0C60.5 548.0 58.2 552.0 55.5 556.0C52.8 560.0 49.9 564.0 47.1 568.0C44.3 572.0 41.5 576.0 38.9 580.0C36.3 584.0 33.9 588.0 31.5 592.0C29.1 596.0 26.2 600.0 24.5 604.0C22.8 608.0 21.7 612.7 21.1 616.0C20.5 619.3 22.0 622.2 21.2 624.0C20.3 625.8 16.9 626.5 16.0 627.0', 17],
    ['M16.0 627.0C17.9 624.5 24.1 616.5 27.6 612.0C31.2 607.5 34.2 604.0 37.3 600.0C40.4 596.0 43.2 592.0 46.3 588.0C49.4 584.0 52.6 580.0 55.9 576.0C59.1 572.0 62.6 568.0 65.8 564.0C69.0 560.0 71.8 556.0 74.8 552.0C77.8 548.0 81.2 544.0 84.0 540.0C86.8 536.0 88.9 532.0 91.6 528.0C94.2 524.0 96.9 520.0 99.9 516.0C102.9 512.0 106.5 508.0 109.6 504.0C112.7 500.0 115.5 496.0 118.3 492.0C121.1 488.0 123.5 484.0 126.3 480.0C129.1 476.0 132.0 472.0 134.9 468.0C137.8 464.0 141.0 460.0 143.9 456.0C146.8 452.0 149.3 448.0 152.1 444.0C154.9 440.0 157.8 436.0 160.7 432.0C163.6 428.0 166.6 424.0 169.7 420.0C172.8 416.0 175.8 412.0 179.1 408.0C182.4 404.0 186.2 400.0 189.7 396.0C193.2 392.0 196.1 388.0 199.9 384.0C203.7 380.0 209.6 375.3 212.5 372.0C215.4 368.7 216.7 365.3 217.5 364.0', 17],
    ['M217.5 364.0C219.4 363.0 225.6 359.6 229.0 358.0C232.4 356.4 235.3 354.5 238.0 354.5C240.7 354.5 243.3 356.1 245.0 358.0C246.7 359.9 247.6 363.0 248.0 366.0C248.4 369.0 247.6 372.7 247.5 376.0C247.4 379.3 247.1 383.2 247.5 386.0C247.9 388.8 248.4 391.8 250.0 393.0C251.6 394.2 254.5 394.0 257.0 393.0C259.5 392.0 262.7 388.9 265.0 387.0C267.3 385.1 269.0 383.2 271.0 381.5C273.0 379.8 275.0 378.3 277.0 377.0C279.0 375.7 281.2 374.8 283.0 373.5C284.8 372.2 286.5 370.2 288.0 369.0C289.5 367.8 291.3 366.5 292.0 366.0', 24]
  ];
  var SIG_R = [[0.0, 444.54], [444.54, 427.53], [872.07, 337.96], [1210.03, 331.86], [1541.89, 118.68]];
  var SIG_TT = [0.0, 8.1, 17.3, 28.6, 42.2, 56.6, 71.0, 85.5, 99.9, 114.3, 128.8, 143.2, 157.6, 172.1, 186.5, 201.0, 215.4, 229.8, 244.3, 258.7, 273.1, 287.6, 302.0, 316.5, 330.9, 345.3, 359.8, 374.2, 388.6, 402.9, 416.8, 430.0, 442.6, 455.1, 468.0, 481.7, 495.9, 510.3, 524.7, 539.2, 553.6, 568.0, 582.5, 596.9, 611.4, 625.8, 640.2, 654.7, 669.1, 683.5, 698.0, 712.4, 726.9, 741.3, 755.7, 770.2, 784.6, 799.0, 813.5, 827.8, 841.8, 855.1, 867.8, 880.2, 893.1, 906.7, 920.8, 935.2, 949.6, 964.0, 978.5, 992.9, 1007.3, 1021.8, 1036.2, 1050.6, 1065.1, 1079.5, 1093.9, 1108.4, 1122.8, 1137.3, 1151.7, 1166.0, 1180.0, 1193.3, 1206.0, 1218.4, 1231.3, 1244.9, 1259.0, 1273.4, 1287.8, 1302.2, 1316.7, 1331.1, 1345.5, 1360.0, 1374.4, 1388.9, 1403.3, 1417.7, 1432.2, 1446.6, 1461.0, 1475.5, 1489.9, 1504.1, 1517.8, 1530.8, 1543.3, 1555.9, 1569.0, 1582.9, 1596.9, 1610.1, 1622.2, 1632.9, 1642.7, 1651.8, 1660.6];
  var SIG_T = 0.62;
  function SIG() {
    var id = 'ffcSig' + (++SIG_N);
    return '<svg class="ffc-sig" id="' + id + '" viewBox="0 0 474 640" aria-hidden="true" focusable="false">' +
      '<rect class="ffc-sig-full" width="474" height="640" fill="currentColor"/>' +
      SIG_P.map(function (q) { return '<path class="ffc-sig-rv" d="' + q[0] + '" pathLength="1" fill="none" stroke="currentColor" stroke-width="' + q[1] + '" stroke-linejoin="round"/>'; }).join('') + '</svg>';
  }
  /* signs everything inside root: each frame reads the pen's distance from SIG_TT and reveals each stroke up to it, then
     the full signature takes over. Returns a stop function. */
  function sigPlay(root, wait, done) {
    var groups = $$('svg.ffc-sig', root).map(function (sv) { return $$('.ffc-sig-rv', sv); }), st = { raf: 0, t: 0 };
    var was = groups.map(function (g) { return g.map(function () { return 1; }); });
    groups.forEach(function (g) { g.forEach(function (pa) { pa.style.strokeDashoffset = '1'; }); });
    root.dataset.rv = '1';
    st.t = setTimeout(function () {
      var t0 = 0, T = SIG_T * 1000, N = SIG_TT.length - 1;
      function frame(now) {
        if (!t0) t0 = now;
        var pr = Math.min(1, (now - t0) / T), x = pr * N, i = Math.min(N - 1, Math.floor(x)), sv = SIG_TT[i] + (SIG_TT[i + 1] - SIG_TT[i]) * (x - i);
        groups.forEach(function (g, gi) { g.forEach(function (pa, j) { var r = SIG_R[j], off = 1 - clamp((sv - r[0]) / r[1], 0, 1); if (off !== was[gi][j]) { was[gi][j] = off; pa.style.strokeDashoffset = off.toFixed(4); } }); });
        if (pr < 1) { st.raf = requestAnimationFrame(frame); return; }
        delete root.dataset.rv;
        groups.forEach(function (g) { g.forEach(function (pa) { pa.style.strokeDashoffset = ''; }); });
        if (done) done();
      }
      st.raf = requestAnimationFrame(frame);
    }, wait || 0);
    return function () { clearTimeout(st.t); cancelAnimationFrame(st.raf); };
  }
  /* front of the card: the ink and the year */
  function frontSignHTML() { return '<div class="cf-sig"><span class="cf-ink">' + SIG() + '</span><span class="cf-yr">' + esc(YEAR) + '</span></div>'; }
  /* Jan's signature with her name and the year under it (card back without a line, certificate on the line) */
  function lineSignHTML(cls) {
    return '<div class="ffc-sgl ' + cls + '"><span class="ffc-sgl-ink">' + SIG() + '</span><span class="ffc-sgl-rule"></span>' +
      '<span class="ffc-sgl-cap"><b>Jan · FramedFantasy</b><small>Signed ' + esc(YEAR) + '</small></span></div>';
  }

  /* ---------------- the Hall card ---------------- */
  function artImg(h) {
    var st = h.imgStyle;
    if (!st) { var f = h.fx || { x: 50, y: 50, z: 100 }; st = 'object-position:' + f.x + '% ' + f.y + '%;transform-origin:' + f.x + '% ' + f.y + '%;' + (f.z && f.z !== 100 ? 'scale:' + (f.z / 100) + ';' : ''); }
    return '<img src="' + esc(h.img) + '" alt="" draggable="false" decoding="async" style="' + esc(st) + '">';
  }
  function frontHTML(h) {
    /* a reserved card carries no signature: Jan hasn't signed it yet (Jan, 2026-10-21, as on the hero page) */
    var art = h.reserved || !h.img
      ? '<div class="cf-canvas"><img src="' + esc(CFG.mono) + '" alt="">' + (h.reserved ? '<p>' + esc((CFG.yours && CFG.yours.reserved) || 'Reserved for your hero') + '</p>' : '') + '</div>' + (h.reserved ? '' : frontSignHTML())
      : '<div class="cf-art">' + artImg(h) + '</div>' + frontSignHTML();
    var type = [h.race, h.cls].filter(Boolean).join(' · ');
    return '<div class="cf cf-front"><div class="cf-in">' + art +
      '<span class="cf-etch"></span><span class="cf-hair"></span>' +
      '<div class="cf-band"><div class="cf-id"><div class="cf-name cf-fl">' + esc(h.name) + '</div>' +
        (type ? '<div class="cf-type">' + esc(type) + '</div>' : '') +
        (h.ep ? '<div class="cf-ep">' + esc(h.ep) + '</div>' : '') +
        (h.quote ? '<div class="cf-q">“' + esc(h.quote) + '”</div>' : '') + '</div>' +
        '<div class="cf-foot">' + numberHTML(h) + '<span class="cf-1">' + editionText(h) + '</span></div></div>' +
      '<span class="cf-glare"></span><span class="cf-sweep"></span></div></div>';
  }
  /* every back, one layout (Jan, 2026-10-21): the header, number, name, title and quote stay put; the story centres in
     the space left; the table row, the credit and the signature sit at the same height on every card. The credit is
     the same on all of them, with FramedFantasy in the brand colours. */
  var CREDIT_HTML = 'Painted by Jan and her team at <b class="cf-ff">FramedFantasy</b>';
  function backHTML(h) {
    if (h.reserved) return '';
    var lg = (h.ledger || []).map(function (r) { return '<div class="cf-lr"><dt>' + esc(r[0]) + '</dt><dd' + (r[2] ? ' data-long="' + esc(r[1]) + '" data-short="' + esc(r[2]) + '"' : '') + '>' + (r[1] == null ? '<i class="cf-blank"></i>' : esc(r[1])) + '</dd></div>'; }).join('');
    /* a back with no story (the visitor's own card) centres its dates and size in the space under the quote, between two
       equal gaps; the credit and everything under it stay put (Jan, 2026-10-23) */
    var gap = h.legend ? '' : '<span class="cf-gap"></span>';
    return '<div class="cf cf-back"><div class="cf-in cf-bk">' +
      '<div class="cf-bk-head"><img src="' + esc(CFG.mono) + '" alt=""><span>Hall of Heroes</span></div>' +
      backNumberHTML(h) +
      '<div class="cf-bk-name">' + esc(h.name) + '</div>' + (h.ep ? '<div class="cf-bk-ep">' + esc(h.ep) + '</div>' : '') +
      (h.quote ? '<q class="cf-bk-q">' + esc(h.quote) + '</q>' : '') +
      (h.legend ? '<div class="cf-story"><p>' + esc(h.legend) + '</p></div>' : gap) +
      /* the dates and size above the credit (Jan, 2026-10-21: "put the commission and size above the painted by jan and
         her team thing"); a hero without a table keeps the row's space, so every back lines up */
      '<dl class="cf-ledger' + (lg ? '' : ' is-empty') + '">' + lg + '</dl>' + gap +
      '<p class="cf-credit">' + CREDIT_HTML + '</p>' +
      '<div class="cf-bk-bot">' + lineSignHTML('cf-bk-sgl') +
        '<div class="cf-bk-check">' + linkHTML(heroUrl(h), h.no && h.slug ? 'Check this card' : 'See the Hall of Heroes', 'cf-link') +
        (h.qr ? '<img class="cf-qr" src="' + esc(h.qr) + '" alt="" onerror="this.style.visibility=\'hidden\'">' : '') + '</div></div>' +
      '<span class="cf-glare"></span><span class="cf-sweep"></span></div></div>';
  }

  /* ---------------- the links on the cards and the certificate (Jan, 2026-10-20) ----------------
     Each hero's card and certificate link to the hero's own page, the same address as its QR code
     (framedfantasy.com/pages/hero?h=<slug>); the visitor's own card, the reserved card and the Full-Body example go
     to the Hall of Heroes. They open in a new tab; in Instagram's and Facebook's own browsers, which have no tabs and
     can drop a new-tab link without opening anything, they open in the same view (the portal's rule, 2026-10-09).
     A link is never focusable on a face that is turned away or on a picture-only copy. */
  var SITE = 'https://framedfantasy.com';
  function heroUrl(h) { return h && h.no && h.slug ? SITE + '/pages/hero?h=' + encodeURIComponent(h.slug) : SITE + '/pages/hall-of-heroes'; }
  /* the address as text that breaks only at its own joints (after the domain, before the ?), never inside a word */
  function shownUrl(url, br) {
    var shown = url.replace(/^https?:\/\//, ''), cut = shown.indexOf('/'), path = shown.slice(cut), q = path.indexOf('?');
    return esc(shown.slice(0, cut)) + (br ? '<br>' : '<wbr>') + (q > 0 ? esc(path.slice(0, q)) + '<wbr><i class="ffc-nwq">' + esc(path.slice(q)) + '</i>' : esc(path));
  }
  function linkHTML(url, title, cls) {
    return '<a class="' + cls + ' ffc-ext" href="' + esc(url) + '" target="_blank" rel="noopener" tabindex="-1"><b>' + esc(title) + '</b>' +
      '<span>' + shownUrl(url, true) + '</span></a>';
  }
  var IN_APP = /FBAN|FBAV|FB_IAB|FB4A|FBIOS|Instagram|Messenger|musical_ly|Bytedance|TikTok|Snapchat|Pinterest|Line\//i.test(navigator.userAgent || '');
  D.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.ffc-ext') : null;
    if (!a) return;
    if (IN_APP) a.removeAttribute('target'); else { a.target = '_blank'; a.rel = 'noopener'; }
  }, true);

  var RO = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { var c = e.target.__card; if (c) c.fit(); var z = e.target.__cert; if (z) z.fit(); }); }) : null;
  var CARDS = [];
  var FONTS_READY = false;
  /* A card is flat at rest (.is-flat, 2026-10-23): one picture painted into the page. In 3D, WebKit keeps each face as a
     layer of its own at the card's full 380 x 650 design size, at a phone's 3 pixels per point, however small it shows:
     the collection's twelve cards held about 300 MB that way, and iPhone browsers ran out of memory and reloaded the page.
     A card that turns over (o.tap 'flip') goes 3D only while it turns or shows its back (api.flip); every other card (the
     collection, which opens the viewer, the gallery thumbnail, What you receive, the reserved card) never turns, so it is
     drawn without a back at all. */
  function Card(host, h, opt) {
    var o = Object.assign({ tap: 'flip', label: null }, opt || {});
    var el = D.createElement('div'); el.className = 'ffc-cc is-flat';
    var api = { el: el, h: h, o: o };
    /* a card that turns over is a group (its back holds a real link, which a button would hide from screen readers);
       a card that opens the viewer stays a button; a picture-only copy is hidden from assistive tech */
    if (o.tap) { el.classList.add('is-tap'); el.tabIndex = 0; el.setAttribute('role', o.tap === 'flip' ? 'group' : 'button'); if (o.tap === 'flip') el.setAttribute('aria-roledescription', 'card'); } else { el.setAttribute('aria-hidden', 'true'); }
    function label() {
      if (!o.tap) return;
      var who = h.reserved ? 'Your card, reserved for your hero' : h.no ? h.name + ', No. ' + h.no + (capOf(editionOf(h.no)) ? ' of ' + capOf(editionOf(h.no)) : '') + (editionOf(h.no) ? ', ' + editionOf(h.no)[1] : '') + ', signed by Jan' : 'Your Hall card, signed by Jan';
      var act = o.tap === 'open' ? ' Open the card.' : (el.classList.contains('is-flipped') ? ' Showing the back. Press to see the front.' : ' Press to turn it over.');
      el.setAttribute('aria-label', who + '.' + act);
    }
    function render() {
      var flipped = el.classList.contains('is-flipped');
      el.innerHTML = '<div class="cc-scale"><div class="cc-tilt"><div class="cc-flip">' + frontHTML(h) + (o.tap === 'flip' ? backHTML(h) : '') + '</div></div></div>';
      el.classList.toggle('is-flipped', flipped);
      faces(); label(); fitText();
    }
    /* only the face that shows is read out and reachable: the other is hidden from assistive tech, its links untabbable */
    function faces() {
      var flipped = el.classList.contains('is-flipped'), live = o.tap === 'flip';
      var fr = $('.cf-front', el), bk = $('.cf-back', el);
      if (live && fr) fr.setAttribute('aria-hidden', String(flipped));
      if (live && bk) bk.setAttribute('aria-hidden', String(!flipped));
      $$('a', el).forEach(function (a) { var onShownFace = live && (a.closest('.cf-back') ? flipped : !flipped); a.tabIndex = onShownFace ? 0 : -1; });
    }
    /* ---- legibility (Jan, 2026-10-20) ----
       A card is laid out at 380px and scaled to its slot, so a line renders at its CSS size times the scale. Every
       line shown renders at 11px or more, with the card's strong colours: a line may grow up to its own limit to get
       there; a line that cannot, or that then no longer fits, is hidden instead of shrunk. A name that does not fit
       on one line wraps to two at full size. Below a quarter scale (the gallery's small thumbnail) the card is a
       picture and shows no lines at all (CSS .cc-pic). The limits are how far each line may grow past its design size. */
    var LEG = [
      ['.cf-front .cf-name', 2.6, 'name'], ['.cf-front .cf-type', 1.6, 'line'], ['.cf-front .cf-ep', 1.9, 'text'], ['.cf-front .cf-q', 2.0, 'text'],
      ['.cf-front .cf-no', 2.0, 'line'], ['.cf-front .cf-1', 1.6, 'line'], ['.cf-front .cf-yr', 1.4, 'line'], ['.cf-front .cf-canvas p', 1.8, 'text'],
      ['.cf-bk-head span', 1.6, 'line'], ['.cf-bk-no', 1.2, 'line'], ['.cf-bk-no small', 1.6, 'part'], ['.cf-bk-sub', 1.6, 'line'],
      ['.cf-bk-name', 1.9, 'name'], ['.cf-bk-ep', 1.9, 'text'], ['.cf-bk-q', 1.8, 'text'], ['.cf-story p', 1.8, 'story'], ['.cf-credit', 1.8, 'text'],
      ['.cf-lr dt', 2.1, 'row'], ['.cf-lr dd', 1.9, 'row'], ['.ffc-sgl-cap b', 1.6, 'line'], ['.ffc-sgl-cap small', 1.7, 'line'],
      ['.cf-link b', 1.6, 'line'], ['.cf-link span', 1.6, 'text']
    ];
    var MIN_PX = 11.05;
    function over(n) { return n.scrollWidth > n.clientWidth + 1; }
    function legible() {
      var s = parseFloat(el.style.getPropertyValue('--s')) || 1, need = MIN_PX / s;
      var items = [];
      LEG.forEach(function (r) { $$(r[0], el).forEach(function (n) { items.push({ n: n, cap: r[1], kind: r[2] }); }); });
      /* back to the design sizes */
      items.forEach(function (it) { it.n.style.fontSize = ''; it.n.classList.remove('ffc-lh', 'is-wrap'); });
      $$('.cf-lr, .cf-story, .cf-ledger', el).forEach(function (x) { x.classList.remove('ffc-lh'); });
      $$('.cf-bk-bot .cf-link', el).forEach(function (a) { a.classList.remove('is-bare'); });
      $$('.cf-lr', el).forEach(function (r) { r.classList.remove('is-tight'); var dd = $('dd[data-long]', r); if (dd) dd.textContent = dd.getAttribute('data-long'); });
      if (s < 0.25 || o.pic) return;
      /* grow each line to the minimum, or hide it when it cannot get there */
      items.forEach(function (it) { it.d = parseFloat(getComputedStyle(it.n).fontSize) || 0; });
      items.forEach(function (it) {
        if (!it.d || it.d >= need) return;
        if (it.d * it.cap >= need) it.n.style.fontSize = need.toFixed(2) + 'px'; else it.n.classList.add('ffc-lh');
      });
      /* the name: a little smaller if it must, never under the minimum, then two lines */
      items.forEach(function (it) {
        if (it.kind !== 'name' || it.n.classList.contains('ffc-lh')) return;
        var n = it.n, size = parseFloat(getComputedStyle(n).fontSize), floor = Math.max(need, 13, size * 0.8), g = 0;
        while (over(n) && size > floor && g++ < 40) { size = Math.max(floor, size - 0.5); n.style.fontSize = size + 'px'; }
        if (over(n)) n.classList.add('is-wrap');
      });
      /* single lines that no longer fit step aside */
      var wide = items.filter(function (it) { return it.kind === 'line' && !it.n.classList.contains('ffc-lh') && over(it.n); });
      wide.forEach(function (it) { it.n.classList.add('ffc-lh'); });
      var foot = $('.cf-front .cf-foot', el), ed = foot && $('.cf-1', foot);
      if (foot && ed && !ed.classList.contains('ffc-lh') && over(foot)) ed.classList.add('ffc-lh');
      /* the check line sits under the signature and the code, full width, on every card (Jan, 2026-10-21: uniform
         backs); when the address still does not fit, it steps aside (the link and the code stay) */
      $$('.cf-bk-bot .cf-link span', el).forEach(function (lk) { if (!lk.classList.contains('ffc-lh') && over(lk)) lk.classList.add('ffc-lh'); });
      /* the room kept for a two-line address goes with the address */
      $$('.cf-bk-bot .cf-link', el).forEach(function (a) { var sp = $('span', a); a.classList.toggle('is-bare', !sp || sp.classList.contains('ffc-lh')); });
      /* a ledger row that runs out of width tightens its label and takes the short date (Oct 21) before anything steps aside */
      $$('.cf-lr', el).forEach(function (r) { if ($('.ffc-lh', r) || !over(r)) return; r.classList.add('is-tight'); var dd = $('dd[data-short]', r); if (dd) dd.textContent = dd.getAttribute('data-short'); });
      /* a ledger row shows whole or not at all */
      $$('.cf-lr', el).forEach(function (r) { if ($('.ffc-lh', r) || over(r)) r.classList.add('ffc-lh'); });
      var lg = $('.cf-ledger', el); if (lg && !lg.classList.contains('is-empty') && !$('.cf-lr:not(.ffc-lh)', lg)) lg.classList.add('ffc-lh');
      /* the front band: when it overflows, the type line, then the title, then the quote step aside */
      var band = $('.cf-front .cf-band', el);
      ['.cf-type', '.cf-ep', '.cf-q'].forEach(function (sel) { if (band && band.scrollHeight > band.clientHeight + 1) { var x = $(sel, band); if (x) x.classList.add('ffc-lh'); } });
      /* the back's story: it may shrink, never under the minimum, then it steps aside */
      var st = $('.cf-story', el);
      if (st) {
        var ts = $$('p', st).filter(function (t) { return !t.classList.contains('ffc-lh'); });
        var base = ts.map(function (t) { return parseFloat(getComputedStyle(t).fontSize) || 15; });
        var kmin = Math.max(0.62, base.length ? need / Math.min.apply(null, base) : 1), k = 1, gg = 0;
        while (st.scrollHeight > st.clientHeight + 1 && k > kmin && gg++ < 20) { k = Math.max(kmin, k - 0.03); ts.forEach(function (t, i) { t.style.fontSize = (base[i] * k).toFixed(2) + 'px'; }); }
        if (st.scrollHeight > st.clientHeight + 1) ts.forEach(function (t) { t.classList.add('ffc-lh'); });
      }
      /* the back as a whole: when it still overflows, the story steps aside first, then the quote and the credit (the
         dates matter more, Jan 2026-10-21), then the ledger rows from the bottom */
      var bk = $('.cf-bk', el), bot = bk && $('.cf-bk-bot', bk);
      if (!bk) return;
      /* full: the footer runs past the bottom padding. Not the scroll height: on a small card the link's invisible tap
         area reaches past the card's edge, and counting it hid lines that fit (Jan, 2026-10-21) */
      var full = function () { return bot ? bot.offsetTop + bot.offsetHeight > bk.clientHeight - (parseFloat(getComputedStyle(bk).paddingBottom) || 0) + 1 : bk.scrollHeight > bk.clientHeight + 1; };
      ['.cf-story p', '.cf-bk-q', '.cf-credit'].forEach(function (sel) { if (full()) { var x = $(sel + ':not(.ffc-lh)', bk); if (x) x.classList.add('ffc-lh'); } });
      if (full()) {
        var rows = $$('.cf-lr:not(.ffc-lh)', bk).reverse();
        for (var i = 0; i < rows.length && full(); i++) rows[i].classList.add('ffc-lh');
      }
      /* last of all, the title, then the address under the check line (its kept room goes with it) */
      ['.cf-bk-ep', '.cf-bk-bot .cf-link span'].forEach(function (sel) { if (full()) { var x = $(sel + ':not(.ffc-lh)', bk); if (x) { x.classList.add('ffc-lh'); var a = x.closest('.cf-link'); if (a) a.classList.add('is-bare'); } } });
    }
    function fitText() {
      if (!el.isConnected || !el.offsetWidth) return;
      legible();
    }
    api.fit = function () {
      var w = host.clientWidth; if (!w) return;
      var s = w / 380; el.style.setProperty('--s', s.toFixed(4));
      el.classList.toggle('cc-sm', s < 0.56); el.classList.toggle('cc-md', s >= 0.56 && s < 0.92); el.classList.toggle('cc-pic', s < 0.25 && !o.pic);
      fitText();
    };
    api.fitText = fitText;
    api.setHero = function (nh) { h = api.h = nh; render(); api.setLook(o.look || resolveYourLook(S.look)); };
    api.setArt = function (src, sz) {
      if (sz && h.ledger) { h.ledger = h.ledger.map(function (r) { return r[0] === 'Size' ? ['Size', sz] : r; }); $$('.cf-lr', el).forEach(function (r) { var dt = $('dt', r); if (dt && dt.textContent === 'Size') $('dd', r).textContent = sz; }); }
      if (!src || src === h.img) return;
      h.img = src;
      var box = $('.cf-art', el); if (!box) { render(); return; }
      var old = $$('img', box), wrap = D.createElement('div'); wrap.innerHTML = artImg(h); var im = wrap.firstChild;
      /* only a card on screen fades to the new picture: a fading picture is a layer of its own, at the card's full design
         size, so a card out of view simply takes it (2026-10-23) */
      var r = el.getBoundingClientRect();
      if (!(r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth)) { old.forEach(function (x) { x.remove(); }); box.appendChild(im); return; }
      im.style.opacity = '0'; box.appendChild(im);
      var go = function () { requestAnimationFrame(function () { im.style.transition = 'opacity .24s ease'; im.style.opacity = '1'; setTimeout(function () { old.forEach(function (x) { x.remove(); }); }, 280); }); };
      if (im.decode) im.decode().then(go, go); else im.onload = go;
    };
    api.flip = function (to) {
      var f = to == null ? !el.classList.contains('is-flipped') : !!to;
      if (f === el.classList.contains('is-flipped')) return;
      /* 3D for the turn and while the back shows; flat again once the card is back on its front */
      clearTimeout(api._flat);
      if (f) el.classList.remove('is-flat');
      if (!rm()) { el.classList.add('is-flipping'); clearTimeout(api._ft); api._ft = setTimeout(function () { el.classList.remove('is-flipping'); }, 640); }
      el.classList.toggle('is-flipped', f); faces(); label();
      if (!f) api._flat = setTimeout(function () { if (!el.classList.contains('is-flipped')) el.classList.add('is-flat'); }, rm() ? 0 : 700);
    };
    api.setLook = function (lk) {
      var fr = FRAMES[lk.frame] || FRAMES.gold, light = !!lk.light;
      var v = light
        ? { g1: lk.g1, g2: lk.g2, line: fr.deep, type: fr.deep, light: fr.deep, name: '#2a2013', text: '#2a2013', mute: '#5b4d39', sig: fr.light, sig2: fr.deep, fa: fr.deep, fb: fr.dk }
        : { g1: lk.g1, g2: lk.g2, line: fr.line, type: fr.type, light: fr.light, name: fr.name, text: '#e8e0d0', mute: '#a8a2b5', sig: fr.light, sig2: fr.light, fa: fr.light, fb: fr.hi };
      v.hi = fr.hi; v.deep = fr.dk;
      Object.keys(v).forEach(function (k) { el.style.setProperty('--cc-' + k, v[k]); });
      el.dataset.ground = light ? 'light' : 'dark'; el.dataset.finish = lk.finish;
    };
    /* the signing moment: Jan's signature writes in, then the year appears */
    api.hideInk = function () { if (api._stop) api._stop(); el.dataset.rv = '0'; };
    api.sign = function () {
      if (api._stop) api._stop();
      if (rm()) { delete el.dataset.rv; return; }
      el.dataset.rv = '0'; void el.offsetWidth;
      api._stop = sigPlay(el, 140);
    };
    el.addEventListener('pointermove', function (e) {
      if (!o.tap || e.pointerType !== 'mouse' || !FINE.matches || rm()) return;
      var r = el.getBoundingClientRect(), px = clamp((e.clientX - r.left) / r.width, 0, 1), py = clamp((e.clientY - r.top) / r.height, 0, 1);
      el.classList.add('is-hover');
      var t = $('.cc-tilt', el); if (t) t.style.transform = 'rotateX(' + ((0.5 - py) * 10).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 14).toFixed(2) + 'deg)';
      el.style.setProperty('--gx', (px * 100).toFixed(1) + '%'); el.style.setProperty('--gy', (py * 100).toFixed(1) + '%'); el.style.setProperty('--mx', (px * 100).toFixed(1));
    });
    el.addEventListener('pointerleave', function () { el.classList.remove('is-hover'); var t = $('.cc-tilt', el); if (t) t.style.transform = ''; });
    if (o.tap) {
      var act = function () { if (o.tap === 'open' && o.onOpen) o.onOpen(api); else if (o.tap === 'flip') api.flip(); };
      /* a tap on a link opens the link and never turns the card */
      el.addEventListener('click', function (e) { e.stopPropagation(); if (e.target.closest && e.target.closest('a')) return; act(); });
      el.addEventListener('keydown', function (e) { if (e.target !== el) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); act(); } });
    }
    render();
    api.setLook(o.look || resolveYourLook(S.look));
    host.appendChild(el); host.__card = api; host.classList.add('is-built');
    if (RO) RO.observe(host);
    api.fit();
    CARDS.push(api);
    return api;
  }
  function dropCard(api) { if (!api) return; api.el.remove(); var i = CARDS.indexOf(api); if (i > -1) CARDS.splice(i, 1); }

  /* ---------------- the certificate: it follows the chosen size (Jan, round 7) ----------------
     Half-Body is Ember (No. 1) and Thigh-Up is Nyx (No. 114), both matched to their Hall paintings. The Full-Body
     painting is not in the Hall, so its certificate is a made-up example (Seraphine Vale, a future number), labelled as
     one in the settings. The words are the setup section's settings, one set per size; the picture is that size's
     own variant picture. A size change redraws every certificate with the full signature showing. */
  function certFor(i) {
    var all = CFG.certs || [], c = all[i] || all[lead] || {}, v = CFG.variants[i] || {};
    return { img: widthUrl(v.img || '', 600), name: c.name || '', short: c.short || c.name || '', type: c.type || '', no: c.no || '', code: c.code || '', qr: c.qr || CFG.qrHall, slug: c.slug || '', size: sizeTitle(i) };
  }
  /* the certificate's check line: that hero's own page, the Full-Body example the Hall of Heroes (its QR code's address) */
  function certLink(c, live) {
    var url = c.slug ? SITE + '/pages/hero?h=' + encodeURIComponent(c.slug) : SITE + '/pages/hall-of-heroes';
    return '<a class="cert-link ffc-ext" href="' + esc(url) + '" target="_blank" rel="noopener"' + (live ? '' : ' tabindex="-1"') + '><b>Check this certificate</b>' +
      '<span>' + shownUrl(url, false) + '</span><em>' + esc(c.code) + '</em></a>';
  }
  /* opt.live: the viewer's certificate, read out and with its link reachable; every other copy is a picture of it
     (hidden from assistive tech, its link untabbable; the gallery's copy still takes a tap on the link) */
  function Cert(host, opt) {
    var api = {}, live = !!(opt && opt.live);
    function draw() {
      var c = certFor(S.size), e = editionOf(+c.no || 0);
      host.innerHTML = '<div class="ffc-cert"' + (live ? '' : ' aria-hidden="true"') + '><div class="cert-in">' +
        '<div class="cert-top"><img src="' + esc(CFG.mono) + '" alt=""><span>FramedFantasy</span></div>' +
        '<div class="cert-h">Certificate of Authenticity</div>' +
        '<div class="cert-art"><img src="' + esc(c.img) + '" alt="" decoding="async"></div>' +
        '<div class="cert-name">' + esc(c.name) + '</div><div class="cert-type">' + esc(c.type) + '</div>' +
        '<div class="cert-no">FramedFantasy No. ' + esc(c.no) + (capOf(e) ? '<span>/' + capOf(e) + '</span>' : '') + '</div>' + (e ? '<div class="cert-found">' + e[1] + '</div>' : '') +
        '<p class="cert-stmt">This certifies that the portrait shown is an original FramedFantasy portrait of ' + esc(c.short) + ', painted for this character by Jan and her team, and approved and signed by Jan.</p>' +
        '<dl class="cert-data"><div><dt>Size</dt><dd>' + esc(c.size) + '</dd></div><div><dt>Format</dt><dd>Digital</dd></div><div><dt>Artwork</dt><dd>1 of 1</dd></div></dl>' +
        '<div class="cert-foot">' + lineSignHTML('cert-sgl') +
          '<div class="cert-check">' + certLink(c, live) + '<span class="cert-qr"><img src="' + esc(c.qr) + '" alt=""></span></div></div>' +
        '</div></div>';
    }
    draw();
    api.fit = function () { var w = host.clientWidth; if (w) { var i = $('.cert-in', host); if (i) i.style.setProperty('--cs', (w / 560).toFixed(4)); } };
    api.update = function () { draw(); api.fit(); };
    function cel() { return $('.ffc-cert', host); }
    api.hideInk = function () { if (api._stop) api._stop(); var c0 = cel(); if (c0) c0.dataset.rv = '0'; };
    api.sign = function () {
      if (api._stop) api._stop();
      var c0 = cel(); if (!c0) return;
      if (rm()) { delete c0.dataset.rv; return; }
      c0.dataset.rv = '0'; void c0.offsetWidth;
      api._stop = sigPlay(c0, 160);
    };
    host.__cert = api; if (RO) RO.observe(host); api.fit();
    return api;
  }

  /* ---------------- the picture: mirror whatever the buy box paints ---------------- */
  var MINE = [];          /* the visitor's own cards: they follow the chosen painting and the customizer */
  function sameUrl(a, b) { return String(a || '').replace(/^https?:/, '') === String(b || '').replace(/^https?:/, ''); }
  /* a new picture fades in over the one showing, then takes its place, so the picture never blinks out (Jan, 2026-10-21:
     "when the images switch from half body to thigh up ... it should smoothly fade into the next images"). It works on
     a stacked picture (position absolute), like the gallery's slides and thumbnails; the copy sits right after it, so
     anything after it (Jan's signature) stays on top. Other pictures dip out and back as before. */
  function swapImg(img, src) {
    if (!img || !src || sameUrl(img.getAttribute('src'), src)) return;
    if (rm()) { img.src = src; return; }
    var host = img.parentNode;
    if (!host || !img.complete || !img.naturalWidth || getComputedStyle(img).position !== 'absolute') {
      img.style.opacity = '0';
      setTimeout(function () { img.src = src; var done = function () { img.style.opacity = '1'; }; if (img.decode) img.decode().then(done, done); else img.onload = done; setTimeout(done, 600); }, 160);
      return;
    }
    if (img.__xf) img.__xf.remove();
    var next = img.cloneNode(false);
    ['id', 'srcset', 'sizes', 'fetchpriority'].forEach(function (a) { next.removeAttribute(a); });
    next.alt = ''; next.setAttribute('aria-hidden', 'true'); next.loading = 'eager'; next.style.opacity = '';
    next.classList.add('ffc-fade', 'ffc-xf');
    img.__xf = next; host.insertBefore(next, img.nextSibling); next.src = src;
    var show = function () {
      if (img.__xf !== next) return;
      void next.offsetWidth; next.classList.add('is-in');
      setTimeout(function () {
        if (img.__xf !== next) return;
        img.src = src;
        var done = function () { if (img.__xf === next) { next.remove(); img.__xf = null; } };
        if (img.decode) img.decode().then(done, done); else done();
      }, 640);
    };
    if (next.decode) next.decode().then(show, show); else { next.onload = show; next.onerror = show; }
  }
  function setArt(src) {
    if (!src || sameUrl(src, S.art)) return;
    S.art = src;
    /* with the size's own files (the gallery's files param) the first painting is that size's first file, so the buy
       box's picture no longer replaces it */
    if (!galFiles()) {
      swapImg($('#ffcGalArt'), widthUrl(src, 1200));
      var t0 = $('#ffcGalT0'); if (t0) t0.src = widthUrl(src, 300);
    }
    swapImg($('#ffcStArt'), widthUrl(src, 800));
    $$('[data-ffc-paint-img]').forEach(function (i) { i.src = widthUrl(src, 120); });
    var bar = $('#ffStickyBar .ff-stickybar__thumb'); if (bar) { bar.removeAttribute('srcset'); bar.src = widthUrl(src, 200); }
    MINE.forEach(function (c) { c.setArt(widthUrl(src, 800), sizeTitle(S.size)); c.setLook(resolveYourLook(S.look)); });
  }
  function galFiles() { var s = $('#ffcGalSets'); return !!(s && s.hasAttribute('data-files')); }
  function watchHero() {
    var img = $('.product__media-list .product__media-item img');
    if (!img || !window.MutationObserver) return;
    new MutationObserver(function () { var s = img.getAttribute('src'); if (s) setArt(s); }).observe(img, { attributes: true, attributeFilter: ['src'] });
  }
  /* the size the visitor pressed, and whether a turn is open */
  function readRows() {
    var rows = $$('#dds-sizes .dds-row');
    var turn = rows.some(function (r) { return r.classList.contains('ffq-turn-tier'); });
    D.documentElement.classList.toggle('ffc-turn', turn);
    var p = rows.filter(function (r) { return r.getAttribute('aria-pressed') === 'true'; })[0];
    var id = p && p.getAttribute('data-variant-id'), i = -1;
    CFG.variants.forEach(function (v, j) { if (String(v.id) === String(id)) i = j; });
    if (i < 0 || i === S.size) return;
    S.size = i;
    /* (the card section's "Shown at <size>" line is gone, Jan 2026-10-23: the card's own Size row still follows) */
    MINE.forEach(function (c) { c.setArt(null, sizeTitle(i)); c.setLook(resolveYourLook(S.look)); });
    [cert.gal, cert.thumb, cert.stack, lb.cert].forEach(function (c) { if (c) c.update(); });
    if (galPaint) galPaint(i);
    /* a lane page has no Dawn gallery to mirror: the card takes the chosen row's painting itself */
    if (CFG.rowArt && CFG.variants[i] && CFG.variants[i].img) setArt(CFG.variants[i].img);
  }
  function watchRows() {
    var box = $('#dds-sizes'); if (!box || !window.MutationObserver) return;
    new MutationObserver(readRows).observe(box, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'class'] });
    readRows();
    /* the status line under the rows speaks only in turn mode or when a checkout add fails */
    var st = $('#dds-status');
    if (st) {
      var say = function () { var t = clean(st.textContent); st.classList.toggle('ffc-say', !!t && !/fully booked|sold out|join the waitlist/i.test(t)); };
      new MutationObserver(say).observe(st, { childList: true, characterData: true, subtree: true });
      say();
    }
  }

  /* ---------------- the gallery ---------------- */
  var card = {}, cert = {}, galPaint = null;
  function buildGallery() {
    var track = $('#ffcGalTrack'); if (!track) return;
    var cols = $('#ffcGsColours'), frs = $('#ffcGsFrames');
    if (cols) cols.innerHTML = '<button type="button" class="ffc-dot" role="radio" data-k="colour" data-v="painting" aria-label="From the painting" title="From the painting"><i><img data-ffc-paint-img src="' + esc(widthUrl(S.art, 120)) + '" alt=""></i></button>' +
      COLOURS.map(function (c) { return '<button type="button" class="ffc-dot" role="radio" data-k="colour" data-v="' + c[0] + '" aria-label="' + c[1] + '" title="' + c[1] + '"><i style="--a:' + c[2] + ';--b:' + c[3] + '"></i></button>'; }).join('');
    if (frs) frs.innerHTML = Object.keys(FRAMES).map(function (k) { var f = FRAMES[k]; return '<button type="button" class="ffc-dot is-metal" role="radio" data-k="frame" data-v="' + k + '" aria-label="' + f.n + ' frame" title="' + f.n + '"><i style="--a:' + f.line + ';--b:' + f.light + '"></i></button>'; }).join('');
    var ctl = $('#ffcGsCtl'); if (ctl) ctl.addEventListener('click', function (e) { var b = e.target.closest('[data-k]'); if (b) setLook(b.dataset.k, b.dataset.v); });
    card.gal = Card($('#ffcGalCard'), yours(), { tap: 'flip' });
    /* a phone-sized gallery card opens full size on its back instead of turning in place */
    $('#ffcGalCard').addEventListener('click', function (e) {
      var sc = parseFloat(card.gal.el.style.getPropertyValue('--s')) || 1;
      if (sc >= 0.5 || (e.target.closest && e.target.closest('a'))) return;
      e.stopPropagation(); e.preventDefault(); openYours(true);
    }, true);
    /* the gallery thumbnail is a picture of the card: a true miniature, so no line is grown or hidden for reading */
    card.thumb = Card($('#ffcGalTCard'), yours(), { tap: false, pic: true });
    MINE.push(card.gal, card.thumb);
    cert.gal = Cert($('#ffcGalCert')); cert.thumb = Cert($('#ffcGalTCert'));
    var gc = $('#ffcGalCert');
    /* a tap on the certificate opens the viewer; a tap on its check line opens that page instead */
    gc.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) return; openCert(); });
    gc.addEventListener('keydown', function (e) { if (e.target !== gc) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCert(); } });
    syncControls();
    /* slides and thumbnails pair up in order; a hidden slide (a size with fewer samples) takes no place */
    var allS = $$('.ffc-gal-s', track), allT = $$('.ffc-gal-t', $('#ffcGalThumbs'));
    /* Jan's signature, bottom left on each painting (Jan, 2026-10-21) */
    $$('.ffc-gal-art', track).forEach(function (a) { var g = D.createElement('span'); g.className = 'ffc-gal-sig'; g.setAttribute('aria-hidden', 'true'); g.innerHTML = SIG(); a.appendChild(g); });
    var shown = function () { return allS.filter(function (x) { return !x.hidden; }); };
    var at = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var renumber = function () { var n = 0; allS.forEach(function (x, k) { var t = allT[k]; if (t) t.dataset.i = x.hidden ? -1 : n; if (!x.hidden) n++; }); };
    var galGo = function (i) { track.scrollTo({ left: i * track.clientWidth, behavior: rm() ? 'auto' : 'smooth' }); };
    var galSync = function () { var i = at(); allT.forEach(function (b) { b.setAttribute('aria-current', String(+b.dataset.i === i)); }); };
    track.addEventListener('scroll', function () { requestAnimationFrame(galSync); }, { passive: true });
    $('#ffcGalThumbs').addEventListener('click', function (e) { var b = e.target.closest('.ffc-gal-t'); if (b && +b.dataset.i >= 0) galGo(+b.dataset.i); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== e.currentTarget) return;
      var i = at();
      if (e.key === 'ArrowRight') { e.preventDefault(); galGo(Math.min(shown().length - 1, i + 1)); } else if (e.key === 'ArrowLeft') { e.preventDefault(); galGo(Math.max(0, i - 1)); }
    });
    addEventListener('resize', galSync);
    /* the chosen size's paintings (Jan, 2026-10-21): slide 0 mirrors the buy box's own picture (setArt); the next two fade
       to that size's samples, named in the template's render call; the gallery stays on the slide in view */
    var SETS = []; try { SETS = JSON.parse(($('#ffcGalSets') || {}).textContent || '[]') || []; } catch (_) {}
    var xs = $$('[data-ffc-gx]', track), painted = false;
    galPaint = function (i) {
      var set = SETS[i] || [], keep = shown()[at()] || allS[0];
      /* the size's own files: its first one is the main painting too (only that size's paintings ever show) */
      if (galFiles() && set[0]) {
        var a0 = $('#ffcGalArt'), t0 = $('#ffcGalT0');
        if (a0) { swapImg(a0, widthUrl(set[0], 1200)); a0.alt = sizeTitle(i) + ' example portrait by FramedFantasy'; }
        if (t0) swapImg(t0, widthUrl(set[0], 300));
      }
      xs.forEach(function (fig, k) {
        var src = set[k + 1], img = $('img', fig), th = allT[allS.indexOf(fig)], timg = th && $('img', th);
        fig.hidden = !src; if (th) th.hidden = !src;
        if (!src) return;
        if (painted) img.loading = 'eager'; swapImg(img, widthUrl(src, 1200)); if (timg) swapImg(timg, widthUrl(src, 300));
        img.alt = sizeTitle(i) + ' example portrait by FramedFantasy'; fig.setAttribute('aria-label', 'Another ' + sizeTitle(i) + ' example');
      });
      renumber();
      var k = allS.indexOf(keep); while (k > 0 && allS[k].hidden) k--;
      var to = shown().indexOf(allS[k]); if (to < 0) to = 0;
      if (to !== at()) track.scrollTo({ left: to * track.clientWidth, behavior: 'auto' });
      galSync();
    };
    renumber(); galPaint(S.size); painted = true;
  }

  /* ---------------- customizers: the compact one on the gallery card, the full one in the card section ---------------- */
  function buildCustomizer() {
    var root = $('#ffcCz'); if (!root) return;
    var html = '<button type="button" class="ffc-chip ffc-chip-wide" role="radio" data-k="colour" data-v="painting"><span class="ffc-sw"><img data-ffc-paint-img src="' + esc(widthUrl(S.art, 120)) + '" alt=""></span><span><b>From the painting</b><small>Matched to your character\'s painting</small></span></button>' +
      '<div><p class="ffc-cz-lab" id="ffcCzLc">Colour</p><div class="ffc-cz-grid ffc-cz-8" role="radiogroup" aria-labelledby="ffcCzLc">' +
        COLOURS.map(function (c) { return '<button type="button" class="ffc-chip" role="radio" data-k="colour" data-v="' + c[0] + '"><span class="ffc-sw" style="--a:' + c[2] + ';--b:' + c[3] + '"></span>' + c[1] + '</button>'; }).join('') +
      '</div></div>' +
      '<div class="ffc-cz-pair"><div><p class="ffc-cz-lab" id="ffcCzLf">Frame</p><div class="ffc-cz-grid ffc-cz-3" role="radiogroup" aria-labelledby="ffcCzLf">' +
        Object.keys(FRAMES).map(function (k) { var f = FRAMES[k]; return '<button type="button" class="ffc-chip" role="radio" data-k="frame" data-v="' + k + '"><span class="ffc-sw is-metal" style="--a:' + f.line + ';--b:' + f.light + '"></span>' + f.n + '</button>'; }).join('') +
      '</div></div><div><p class="ffc-cz-lab" id="ffcCzLx">Finish</p><div class="ffc-cz-grid ffc-cz-3" role="radiogroup" aria-labelledby="ffcCzLx">' +
        FINISHES.map(function (f) {
          var bg = f[0] === 'matte' ? 'background:linear-gradient(160deg,#2a2418,#14110d)' : f[0] === 'foil' ? 'background:linear-gradient(110deg,#b48c3c,#fff1c4 40%,#c8a45e 55%,#fff1c4 75%,#b48c3c)' : 'background:repeating-linear-gradient(135deg,rgba(242,217,142,.32) 0 1px,transparent 1px 5px),linear-gradient(160deg,#2a2418,#14110d);box-shadow:inset 0 0 0 1px rgba(242,217,142,.35)';
          return '<button type="button" class="ffc-chip" role="radio" data-k="finish" data-v="' + f[0] + '"><span class="ffc-sw is-fin" style="' + bg + '"></span>' + f[1] + '</button>';
        }).join('') +
      '</div></div></div>';
    root.insertAdjacentHTML('beforeend', html);
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-k]'); if (b) setLook(b.dataset.k, b.dataset.v); });
    syncControls();
  }
  function syncControls() { $$('#ffcCz [data-k], #ffcGsCtl [data-k]').forEach(function (b) { b.setAttribute('aria-checked', String(S.look[b.dataset.k] === b.dataset.v)); }); }
  function setLook(k, v) {
    if (S.look[k] === v) return;
    var l = Object.assign({}, S.look); l[k] = v; S.look = l;
    syncControls();
    MINE.forEach(function (c) { c.setLook(resolveYourLook(l)); });
  }

  /* ---------------- What you receive: the pile settles, each row lifts its piece ---------------- */
  var pinned = null;
  function buildReceive() {
    var st = $('#ffcStack'), list = $('#ffcRcvList'); if (!st) return;
    card.stack = Card($('#ffcStCard'), yours(), { tap: false }); MINE.push(card.stack);
    cert.stack = Cert($('#ffcStCert'));
    var lift = function (k) { st.classList.toggle('is-focus', !!k); $$('.ffc-so', st).forEach(function (o) { o.classList.toggle('is-on', !!k && o.dataset.k === k); }); };
    var rows = list ? $$('.ffc-ri', list) : [];
    var setFocus = function (i) {
      pinned = i < 0 ? null : i;
      lift(i < 0 ? '' : rows[i].dataset.k);
      rows.forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
    };
    rows.forEach(function (b, i) { b.addEventListener('click', function () { setFocus(b.getAttribute('aria-pressed') === 'true' ? -1 : i); }); });
    if (FINE.matches && list) {
      list.addEventListener('pointerover', function (e) { var b = e.target.closest('.ffc-ri'); if (b && pinned == null) lift(b.dataset.k); });
      list.addEventListener('pointerleave', function () { if (pinned == null) lift(''); });
    }
    $$('.ffc-so', st).forEach(function (o) { o.addEventListener('click', function () { var i = -1; rows.forEach(function (b, j) { if (i < 0 && b.dataset.k === o.dataset.k) i = j; }); setFocus(pinned === i ? -1 : i); }); });
    /* the orchestrated moment: the pieces start as a pile and settle into place as the stack scrolls in */
    if (rm() || !('IntersectionObserver' in window) || st.getBoundingClientRect().top < innerHeight * 1.05) return;
    var r = st.getBoundingClientRect();
    $$('.ffc-so', st).forEach(function (o) { var b = o.getBoundingClientRect(); o.style.setProperty('--px', ((r.left + r.width / 2) - (b.left + b.width / 2)).toFixed(1) + 'px'); o.style.setProperty('--py', ((r.top + r.height * .45) - (b.top + b.height / 2)).toFixed(1) + 'px'); });
    st.classList.add('is-pile');
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); setTimeout(function () { $$('.ffc-so', st).forEach(function (o) { o.style.setProperty('--px', '0px'); o.style.setProperty('--py', '0px'); }); st.classList.remove('is-pile'); }, 120); } }); }, { threshold: 0.35 });
    io.observe(st);
  }

  /* ---------------- a lane page's gallery: its card thumbnail and the card in the big frame ---------------- */
  function buildMine() {
    $$('[data-ffc-mine]').forEach(function (host) {
      var pic = host.getAttribute('data-ffc-mine') === 'pic';
      MINE.push(Card(host, yours(), pic ? { tap: false, pic: true } : { tap: 'flip' }));
    });
  }

  /* ---------------- the Hall card section ---------------- */
  function buildStage() {
    var host = $('#ffcCsCard'); if (!host) return;
    card.stage = Card(host, yours(), { tap: 'flip' }); MINE.push(card.stage);
    buildCustomizer();
    showcase();
  }
  /* the showcase (Jan, 2026-10-21: "have the color and frame and finish subtly get selected and picked so the card
     subtly changes to showcase all the designs smoothly"). While nobody has touched the choices, the card in this
     section steps through every colour, with a frame or a finish change between them, one choice every 2.8 seconds,
     and the chips follow; the colours blend (the --cc-* properties in ff-collector.css). The first press, key or focus
     in either set of choices stops it for good and keeps what is showing. It waits while the card is off screen or the
     tab is hidden, and never runs with reduced motion. The look is only a preview here; none of it goes to the cart. */
  function showcase() {
    var host = $('#ffcCsCard'); if (!host || rm() || !('IntersectionObserver' in window)) return;
    var turns = [['frame', 'silver'], ['finish', 'foil'], ['frame', 'copper'], ['finish', 'etched'], ['frame', 'gold'], ['finish', 'matte'], ['frame', 'silver'], ['finish', 'foil']];
    var steps = [];
    COLOURS.forEach(function (c, i) { steps.push(['colour', c[0]]); if (turns[i]) steps.push(turns[i]); });
    steps.push(['colour', 'painting'], ['frame', 'gold'], ['finish', 'matte']);
    var at = 0, timer = 0, seen = false, done = false;
    /* while it runs, each look blends in over 1.6 s, eased, with the chips gliding along (html.ffc-tour in
       ff-collector.css; Jan, 2026-10-21: "when it shifts to another one make it look smoother") */
    D.documentElement.classList.add('ffc-tour');
    function tick() { timer = 0; if (done || !seen || D.hidden) return; var s = steps[at++ % steps.length]; setLook(s[0], s[1]); timer = setTimeout(tick, 2800); }
    function go() { if (!timer && !done && seen && !D.hidden) timer = setTimeout(tick, 1600); }
    function halt() { clearTimeout(timer); timer = 0; }
    function stop() { if (done) return; done = true; halt(); io.disconnect(); D.documentElement.classList.remove('ffc-tour'); }
    var io = new IntersectionObserver(function (es) { seen = es.some(function (e) { return e.isIntersecting; }); if (seen) go(); else halt(); }, { threshold: 0.35 });
    io.observe(host);
    D.addEventListener('visibilitychange', function () { if (D.hidden) halt(); else go(); });
    ['#ffcCz', '#ffcGsCtl'].forEach(function (sel) { var r = $(sel); if (r) ['pointerdown', 'keydown', 'focusin'].forEach(function (ev) { r.addEventListener(ev, stop); }); });
  }
  /* every signature signs itself the first time its card or certificate comes into view; the viewer signs on each open */
  function armSignOnView(api, host, thr) {
    if (!api || !host || rm() || !('IntersectionObserver' in window)) return;
    api.hideInk();
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); api.sign(); } }); }, { threshold: thr || 0.5 });
    io.observe(host);
  }
  function armSign() {
    [[card.gal, $('#ffcGalCard')], [card.stack, $('#ffcStCard')], [card.stage, $('#ffcCsCard')], [cert.gal, $('#ffcGalCert')], [cert.stack, $('#ffcStCert')]].forEach(function (p) { armSignOnView(p[0], p[1]); });
  }

  /* ---------------- the Hall: one read of Jan's hand-picked list, for the collection and the strip ---------------- */
  var hallPromise = null;
  function hall() {
    if (hallPromise) return hallPromise;
    hallPromise = new Promise(function (resolve) {
      var tries = 0;
      (function wait() {
        if (window.ffShowcase && ffShowcase.get) {
          ffShowcase.get({ count: 200, cards: true, fill: false, stories: false, shuffle: false }).then(resolve, function () { resolve([]); });
        } else if (tries++ < 60) setTimeout(wait, 100);
        else resolve([]);
      })();
    });
    return hallPromise;
  }
  function sharpUrl(full) {
    var m = /^(https:\/\/[^/]+\/storage\/v1\/)object(\/public\/[^?#]+)/.exec(full || '');
    return m ? m[1] + 'render/image' + m[2] + '?width=760&height=760&resize=cover&quality=80' : '';
  }
  function heroFromHost(host, r) {
    var d = host.dataset, c = (r && r.card) || {};
    var ep = clean(c.epithet || '') || d.ep || '';
    var name = r ? clean(r.name) : d.name;
    if (r && ep && name.toLowerCase().slice(-(ep.length + 2)) === (', ' + ep).toLowerCase()) name = name.slice(0, -(ep.length + 2));
    var h = {
      key: 'c' + d.no, no: +d.no || null, slug: d.slug,
      name: name || d.name, race: (r && clean(r.race)) || d.race, cls: (r && clean(r.characterClass)) || d.cls, ep: ep,
      quote: clean(c.quote || '') || d.quote, legend: clean(c.legend || '') || d.legend,
      img: r ? (r.thumb || r.image) : (d.fbImg || ''), full: r ? r.image : '', imgStyle: r ? r.imageStyle : '',
      fx: { x: +d.fx || 50, y: +d.fy || 50, z: 100 },
      qr: d.qr,
      table: (r && clean(r.campaign)) || d.table
    };
    h.ledger = h.table ? [['Table', h.table]] : [];
    h.look = { g1: d.g1, g2: d.g2, frame: d.frame || 'gold', finish: d.finish || 'matte', light: d.light === '1' };
    return h;
  }

  /* ---------------- the collection ---------------- */
  var COLL = [];
  function buildCollection(rows) {
    var by = {};
    (rows || []).forEach(function (r) { if (r && r.slug) by[r.slug] = r; });
    $$('#ffcHwGrid [data-ffc-hero]').forEach(function (host) {
      var h = heroFromHost(host, by[host.dataset.slug]);
      var i = COLL.length;
      COLL.push(h);
      var api = Card(host, h, { tap: 'open', look: h.look, onOpen: function () { openCard(i); } });
      armSignOnView(api, host, 0.55);
    });
    /* the reserved card is a link to the Hall of Heroes, where the visitor's hero will hang */
    var y = $('#ffcHwGrid [data-ffc-yours]');
    if (y) {
      var a = D.createElement('a');
      a.className = 'ffc-cc-link ffc-ext'; a.href = SITE + '/pages/hall-of-heroes'; a.target = '_blank'; a.rel = 'noopener';
      a.setAttribute('aria-label', 'Your card, reserved for your hero. See the Hall of Heroes');
      y.appendChild(a); y.classList.add('is-built');
      /* unsigned, and no line under the name (Jan, 2026-10-21); the section's "Reserved card line" can still add one */
      Card(a, { key: 'reserved', reserved: true, name: (CFG.yours && CFG.yours.name) || 'Your hero', race: '', ep: y.dataset.ep || '', no: nextNo() }, { tap: false, look: { g1: '#15121a', g2: '#0a0a0f', frame: 'gold', finish: 'matte' } });
    }
    if (FONTS_READY) CARDS.forEach(function (c) { c.fitText(); });
  }
  function armCollection() {
    var grid = $('#ffcHwGrid'); if (!grid) return;
    var started = false;
    var go = function () {
      if (started) return; started = true;
      var timer = new Promise(function (r) { setTimeout(function () { r(null); }, 4000); });
      Promise.race([hall(), timer]).then(function (rows) {
        if (!rows) { buildCollection([]); return; }
        var want = $$('#ffcHwGrid [data-ffc-hero]').map(function (h) { return h.dataset.slug; });
        var have = {}; rows.forEach(function (r) { have[r.slug] = 1; });
        var missing = want.filter(function (s) { return s && !have[s]; });
        if (!missing.length || !window.ffShowcase) { buildCollection(rows); return; }
        /* a hero Jan has since unticked from her list: the full FramedFantasy list still has them */
        ffShowcase.get({ count: 200, cards: true, fill: true, stories: false, shuffle: false }).then(function (all) { buildCollection(rows.concat(all || [])); }, function () { buildCollection(rows); });
      });
    };
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '900px 0px' });
    io.observe(grid);
  }

  /* ---------------- the viewer ---------------- */
  var lb = { el: null, i: 0, card: null, last: null, cert: null };
  function viewer() {
    if (lb.el) return lb.el;
    var el = D.createElement('div');
    el.className = 'ffc-lb ffc-root'; el.id = 'ffcLb'; el.hidden = true;
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Hall card');
    el.innerHTML = '<button type="button" class="ffc-lb-x" aria-label="Close"><svg viewBox="0 0 18 18" aria-hidden="true"><path d="M4 4l10 10M14 4L4 14"/></svg></button>' +
      '<div class="ffc-host ffc-lb-host"></div><div class="ffc-certhost ffc-lb-cert" hidden></div>' +
      '<div class="ffc-lb-side"><p class="ffc-lb-cap">Tap the card to turn it over</p><div class="ffc-lb-row">' +
      '<button type="button" class="ffc-lb-nav" data-d="-1" aria-label="Previous card"><svg viewBox="0 0 18 18" aria-hidden="true"><path d="M11 4L6 9l5 5"/></svg></button>' +
      '<span class="ffc-lb-count"></span>' +
      '<button type="button" class="ffc-lb-nav" data-d="1" aria-label="Next card"><svg viewBox="0 0 18 18" aria-hidden="true"><path d="M7 4l5 5-5 5"/></svg></button></div></div>';
    D.body.appendChild(el);
    $('.ffc-lb-x', el).addEventListener('click', closeViewer);
    $$('.ffc-lb-nav', el).forEach(function (b) { b.addEventListener('click', function () { showCard(lb.i + (+b.dataset.d)); }); });
    el.addEventListener('click', function (e) { if (e.target === el) closeViewer(); });
    D.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      var isC = el.classList.contains('is-cert');
      if (e.key === 'Escape') closeViewer();
      else if (!isC && !el.classList.contains('is-one') && e.key === 'ArrowRight') showCard(lb.i + 1);
      else if (!isC && !el.classList.contains('is-one') && e.key === 'ArrowLeft') showCard(lb.i - 1);
      else if (e.key === 'Tab') { var f = $$('button, [tabindex="0"]', el).filter(function (n) { return n.offsetParent !== null; }); if (!f.length) return; var a = f[0], z = f[f.length - 1]; if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); } }
    });
    lb.el = el;
    return el;
  }
  function showCard(i) {
    var el = viewer();
    lb.i = (i + COLL.length) % COLL.length;
    var h = Object.assign({}, COLL[lb.i]);
    dropCard(lb.card);
    lb.card = Card($('.ffc-lb-host', el), h, { tap: 'flip', look: h.look });
    lb.card.fit(); lb.card.fitText();
    $('.ffc-lb-count', el).textContent = (lb.i + 1) + ' / ' + COLL.length;
    /* a sharper picture once it has loaded; the 400px thumbnail shows first */
    var sharp = sharpUrl(h.full), c = lb.card;
    if (sharp) { var pre = new Image(); pre.onload = function () { if (lb.card === c) c.setArt(sharp); }; pre.src = sharp; }
    c.sign();
  }
  function openViewer(isCert) {
    var el = viewer();
    lb.last = D.activeElement;
    el.classList.toggle('is-cert', !!isCert);
    el.setAttribute('aria-label', isCert ? 'Certificate of authenticity' : 'Hall card');
    $('.ffc-lb-cert', el).hidden = !isCert;
    el.hidden = false;
    D.documentElement.classList.add('ffc-lock');
  }
  function openCard(i) {
    openViewer(false); lb.el.classList.remove('is-one'); showCard(i);
    requestAnimationFrame(function () { lb.el.classList.add('on'); if (lb.card) lb.card.el.focus(); });
  }
  /* the visitor's own card, full size and turned to the back: on a phone the gallery card is too small for its back to
     be read at 11px or more, so a tap opens it here instead of turning it in place (Jan, 2026-10-21) */
  function openYours(back) {
    openViewer(false); lb.el.classList.add('is-one');
    dropCard(lb.card);
    lb.card = Card($('.ffc-lb-host', lb.el), yours(), { tap: 'flip', look: resolveYourLook(S.look) });
    lb.card.fit(); lb.card.fitText(); if (back) lb.card.flip(true);
    requestAnimationFrame(function () { lb.el.classList.add('on'); if (lb.card) lb.card.el.focus(); });
  }
  function openCert() {
    openViewer(true);
    var host = $('.ffc-lb-cert', lb.el);
    if (!lb.cert) lb.cert = Cert(host, { live: true });
    requestAnimationFrame(function () { lb.cert.fit(); lb.cert.sign(); lb.el.classList.add('on'); $('.ffc-lb-x', lb.el).focus(); });
  }
  function closeViewer() {
    var el = lb.el; if (!el) return;
    el.classList.remove('on');
    D.documentElement.classList.remove('ffc-lock');
    setTimeout(function () { el.hidden = true; dropCard(lb.card); lb.card = null; }, rm() ? 0 : 220);
    if (lb.last && lb.last.focus) lb.last.focus({ preventScroll: true });
  }

  /* ---------------- "In the Hall": three columns of Jan's picks, falling slowly (Jan, round 4) ---------------- */
  function buildHallWall() {
    var walls = $$('[data-ffc-hallwall]'); if (!walls.length) return;
    var go = function () {
      hall().then(function (rows) {
        var list = (rows || []).filter(function (r) { return r && r.thumb && r.thumb !== r.image; });
        if (list.length < 9) return;            /* too few: the Hall picture under it stays */
        for (var i = list.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = list[i]; list[i] = list[j]; list[j] = t; }
        list = list.slice(0, 24);
        walls.forEach(function (w) {
          var cols = [[], [], []]; list.forEach(function (r, i) { cols[i % 3].push(r); });
          w.innerHTML = cols.map(function (c, k) {
            var imgs = c.map(function (r) { return '<span><img src="' + esc(r.thumb) + '" alt="" width="400" height="400" decoding="async" draggable="false" style="' + esc(r.imageStyle) + '"></span>'; }).join('');
            /* one speed for every column (time grows with the number of portraits); the middle column rises, the outer two fall */
            return '<div class="ffc-hw3-col"><div class="ffc-hw3-track' + (k === 1 ? ' is-up' : '') + '" style="--d:' + (c.length * 6) + 's;--o:-' + [8, 37, 21][k] + 's">' + imgs + imgs + '</div></div>';
          }).join('');
          w.hidden = false; if (w.parentNode) w.parentNode.classList.add('is-wall');
          if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { w.classList.toggle('is-paused', !e.isIntersecting); }); }).observe(w);
        });
      });
    };
    if (!('IntersectionObserver' in window)) { go(); return; }
    /* watch the tile row, not the tile: on phones the Hall tile starts off screen inside the swipe row */
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '700px 0px' });
    walls.forEach(function (w) { io.observe(w.closest('ul') || w.parentNode); });
  }


  /* ---------------- "At your table" data: Jan's picks framed on their faces (Jan, rounds 6 to 9) ----------------
     The tile carries the roster as data (slug, name and where the face is: across %, down %), the first
     hero's own picture, and a bundled copy of each portrait. Jan's live hand-picked list decides who is offered and
     supplies the current picture by slug; a hero who leaves the list leaves the roster. While the Hall is slow or
     down, the bundled copies stand in, so the game never waits and never empties. */
  function vttHeroes(b) {
    var list = [];
    try { list = JSON.parse(b.getAttribute('data-heroes') || '[]'); } catch (e) { list = []; }
    var tile = b.getAttribute('data-tile') || '';
    return list.filter(function (h) { return h && h.n; }).map(function (h, i) {
      var src = i === 0 && tile ? tile : (h.fallback || '');
      return { slug: h.slug || '', n: h.n, fx: +h.fx || 50, fy: +h.fy || 20, fallback: h.fallback || '', tile: i === 0 ? tile : '', src: src, on: !!src };
    });
  }
  function vttRoster(list, rows) {
    var live = {}, any = false;
    (rows || []).forEach(function (r) { if (r && r.slug) { live[r.slug] = r; any = true; } });
    if (!any) return;                       /* the Hall did not answer: keep the bundled copies */
    list.forEach(function (h, i) {
      var r = live[h.slug], thumb = r && r.thumb && r.thumb !== r.image ? r.thumb : '';
      if (i === 0 && h.tile) { h.on = true; return; }
      h.on = !!r;
      if (r) h.src = thumb || h.fallback || r.image;
    });
  }

  /* "At your table" v5 (Jan, 2026-10-21): "make it like a start button and when they start just show like 3 heroes
     and 4 golbins there ... have like 3 waves the 3rd wave being like a boss". The tile is a still board: three of
     Jan's heroes facing four Battlegrounds goblins, with a Start button. The game (ff-collector-vtt.js and .css, the
     tile's data-game and data-game-css) loads once the tile comes near the screen and opens over the page; its rules
     are at the top of that file. The party is Jaezlan, Ember and Lyrabelle, because their moves fit a Fighter, a
     Cleric and a Wizard; the tile's roster frames each face, Jan's live picks supply the current picture, and the
     bundled copies stand in while the Hall is slow or down. The whole tile starts the game; the button carries focus.
     v7 (Jan, 2026-10-21: "go up to round 5 ... pick from Jan's favorites every time so that its a random 3 characters
     everytime you win/lose"): five rounds, rival parties from round 4. The tile hands the game Jan's picks as its pool
     (name, class and thumbnail; the roster's hand-tuned framing where it has the hero), and once both the pool and the
     game are here it asks the game for a fair random party (FFCVtt.roll) and paints those three, so the faces on the
     tile are the party Start plays. A new run's party repaints the tile through the game's state. */
  var GOB_GLYPH = '<path d="M4 14c2-5 4-7 8-7s6 2 8 7l-3 6H7z"/><path d="M7 8 3 4l1 7m13-3 4-4-1 7" fill="none" stroke-width="1.5"/><g fill="#141b13" stroke="none"><circle cx="9" cy="13" r="1.25"/><circle cx="15" cy="13" r="1.25"/></g><path d="M10 17h4" stroke="#141b13" fill="none" stroke-width="1"/>';
  var VTT_ZOOM = 115;   /* the portrait at most 15% larger than the token, framed on the face (Jan, 2026-10-20) */
  var VTT_PARTY = ['jaezlan-baenre', 'ember', 'lyrabelle'];
  function vttFace(h) {
    var z = VTT_ZOOM, lo = 100 - z;
    return 'width:' + z + '%;height:' + z + '%;left:' + clamp(50 - h.fx * z / 100, lo, 0).toFixed(1) + '%;top:' + clamp(46 - h.fy * z / 100, lo, 0).toFixed(1) + '%';
  }
  function buildVtt(b) {
    if (!b || b.__vtt) return; b.__vtt = true;
    var list = vttHeroes(b), js = b.getAttribute('data-game'), css = b.getAttribute('data-game-css');
    if (!list.length || !js) return;
    function party() {
      var by = {}, p = [];
      list.forEach(function (h) { by[h.slug] = h; });
      VTT_PARTY.forEach(function (s) { if (by[s]) p.push(by[s]); });
      list.forEach(function (h) { if (p.length < 3 && p.indexOf(h) < 0) p.push(h); });
      return p.slice(0, 3).map(function (h) { return { slug: h.slug, n: h.n, src: h.src || h.fallback, fx: h.fx, fy: h.fy }; });
    }
    /* six by six squares: the heroes bottom left, the goblins top right, the button between them */
    var HS = [[0, 3], [1, 4], [0, 5]], GS = [[3, 0], [5, 0], [4, 1], [5, 2]];
    var at = function (c) { return 'left:' + (c[0] * 100 / 6 + 1.333).toFixed(3) + '%;top:' + (c[1] * 100 / 6 + 1.333).toFixed(3) + '%'; };
    /* the three faces on the tile: a party's own pictures and framing */
    function paint(q) {
      q = q || party();
      $$('.ffc-vtt-t.is-h', b).forEach(function (el, i) {
        var h = q[i], img = h && $('img', el); if (!img) return;
        if (img.getAttribute('src') !== h.src) img.src = h.src;
        img.setAttribute('style', vttFace(h));
      });
      return q;
    }
    var p = party(), pool = [], rolled = false, opened = false;
    b.innerHTML = p.map(function (h, i) { return '<span class="ffc-vtt-t is-h" style="' + at(HS[i]) + '"><span class="ffc-u-tok"><img src="' + esc(h.src) + '" alt="" draggable="false" style="' + vttFace(h) + '"></span></span>'; }).join('') +
      GS.map(function (c) { return '<span class="ffc-vtt-t is-g" style="' + at(c) + '"><span class="ffc-u-tok"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><g fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' + GOB_GLYPH + '</g></svg></span></span>'; }).join('') +
      '<button type="button" class="ffc-vtt-go"><i aria-hidden="true"><svg viewBox="0 0 16 16"><path d="M5.5 3.6v8.8L12.4 8z"/></svg></i><span><b>Start the fight</b><small>3 heroes, 5 rounds, 2 bosses</small></span></button>';
    b.classList.add('is-live');
    var go = $('.ffc-vtt-go', b), lab = $('b', go), sub = $('small', go);
    /* Jan's picks as the game's pool: the roster's own picture and framing where it has the hero, the Hall's
       thumbnail framed a little above the middle (where the heads sit in its square crops) for everyone else */
    function toPool(rows) {
      var mine = {}; list.forEach(function (h) { mine[h.slug] = h; });
      return (rows || []).filter(function (r) { return r && r.slug && r.name && (r.thumb || r.image); }).map(function (r) {
        var h = mine[r.slug];
        return { slug: r.slug, n: r.name, cls: r.characterClass || '', race: r.race || '', src: h && h.src ? h.src : r.thumb || r.image, fx: h ? h.fx : 50, fy: h ? h.fy : 28 };
      });
    }
    /* once the game is here, the tile shows the fair random party Start will play, so every run's party is random (Jan,
       2026-10-22: "make sure the party the user gets is always random every turn"). Before Jan's picks answer, the roll
       comes from the tile's own roster, and it is rolled once more from her picks when they arrive, if the game hasn't
       opened yet */
    function roll() {
      if (rolled === true || opened || !window.FFCVtt || typeof FFCVtt.roll !== 'function') return;
      if (rolled && !pool.length) return;
      var from = pool.length ? pool : list.filter(function (h) { return h.on && h.src; }).map(function (h) { return { slug: h.slug, n: h.n, src: h.src, fx: h.fx, fy: h.fy }; });
      var q = null; try { q = FFCVtt.roll(from); } catch (e) { q = null; }
      if (q && q.length === 3) { rolled = pool.length ? true : 'roster'; p = q; paint(p); }
    }
    hall().then(function (rows) { vttRoster(list, rows); pool = toPool(rows); if (!rolled) p = paint(); roll(); });
    var got = { js: !!window.FFCVtt, css: !css }, waiting = null, asked = false;
    function load() {
      if (asked) return; asked = true;
      if (!got.css) { var l = D.createElement('link'); l.rel = 'stylesheet'; l.href = css; l.onload = l.onerror = function () { got.css = true; ready(); }; D.head.appendChild(l); }
      if (!got.js) {
        var s = D.createElement('script'); s.src = js; s.async = true;
        s.onload = function () { got.js = true; roll(); ready(); };
        s.onerror = function () { s.remove(); asked = false; go.classList.remove('is-loading'); sub.textContent = 'It did not load. Tap to try again.'; };
        D.head.appendChild(s);
      }
    }
    function ready() { if (got.js && got.css && waiting) { var f = waiting; waiting = null; f(); } }
    function state(st) {
      if (!st) return;
      b.classList.toggle('is-started', !!(st.started || st.ended));   /* the board stops being blurred */
      /* the label says what a tap opens: a win nobody has seen yet (the last blow, then Close) opens its victory, a loss
         opens the defeat card with a new party, and a seen win opens a fresh run (Jan, 2026-10-21). A game from before
         v7 (a cached copy) still reads in waves of three */
      var unseen = st.ended && st.seen === false, lost = !st.ended && st.phase === 'lost';
      var n = st.round || st.wave || 1, of = st.rounds || 3, word = st.rounds ? 'round ' : 'wave ', Word = st.rounds ? 'Round ' : 'Wave ';
      /* (2026-10-28, Jan: a won camp reopens on its victory, not a fresh run; Play again lives on the reward card) */
      lab.textContent = unseen || st.ended ? 'See your victory' : lost ? (st.rounds ? 'Try a new party' : 'Try wave ' + n + ' again') : st.started ? 'Continue the fight' : 'Start the fight';
      /* every run starts at round 1 (the round-4 checkpoint is gone, Jan 2026-10-22), so a win is all of them */
      sub.textContent = st.ended ? (st.rounds ? 'All ' + of + ' rounds won' : 'The goblin camp is cleared') : lost ? 'The party fell in ' + word + n : st.started ? Word + n + ' of ' + of : '3 heroes, 5 rounds, 2 bosses';
      /* a new run rolls a new party: the tile shows it; after a loss, the party the next one plays (st.next: the defeat
         card's promise); after a win, the party that won, since a tap opens their victory. The faces on the tile are always
         the ones a tap brings */
      var show = !st.ended && st.next && st.next.length === 3 ? st.next : st.party;
      if (show && show.length === 3 && show.some(function (h, i) { return !p[i] || p[i].slug !== h.slug; })) { p = show; paint(p); }
    }
    function start() {
      waiting = function () { go.classList.remove('is-loading'); opened = true; window.FFCVtt.open({ party: p, pool: pool, from: go, onState: state }); };
      if (got.js && got.css) { ready(); return; }
      go.classList.add('is-loading'); load();
    }
    b.addEventListener('click', function (e) { e.preventDefault(); start(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '500px 0px' });
      io.observe(b.closest('ul') || b);
    } else load();
  }

  /* "On your wall": real walls, one photo at a time, fading slowly. A tap or Enter fades straight to the next. */
  /* "On your wall" (Jan, rounds 6 and 10): the photos cross-fade over 1.6s. The next photo is loaded a step ahead
     and decoded before it fades in; the new photo fades in on top while the old one stays fully shown underneath
     (.was) until it is covered, so a change is never a cut and never dips through the dark tile. */
  function buildUWall(w) {
    if (!w || w.__uw) return; w.__uw = true;
    var ims = $$('img', w), dots = $('.ffc-uw-dots', w), i = 0, timer = 0, seen = false, busy = false, wasT = 0;
    if (ims.length < 2 || !dots) return;
    dots.innerHTML = ims.map(function (_, k) { return '<i' + (k ? '' : ' class="on"') + '></i>'; }).join('');
    var ds = $$('i', dots);
    /* a photo waiting in data-ffc-src gets its src now; resolves once it can paint (or fails softly) */
    function ready(im) {
      var src = im.getAttribute('data-ffc-src');
      if (src && !im.getAttribute('src')) { im.loading = 'eager'; im.setAttribute('src', src); im.removeAttribute('data-ffc-src'); }
      else if (im.loading === 'lazy') im.loading = 'eager';
      if (im.complete && im.naturalWidth) return im.decode ? im.decode().catch(function () {}) : Promise.resolve();
      return new Promise(function (res) {
        var done = function () { im.removeEventListener('load', done); im.removeEventListener('error', done); res(); };
        im.addEventListener('load', done); im.addEventListener('error', done);
        setTimeout(done, 6000);
      }).then(function () { return im.decode && im.naturalWidth ? im.decode().catch(function () {}) : null; });
    }
    function go(n) {
      if (busy) return;
      var nx = (n + ims.length) % ims.length, tries = 0;
      while (ims[nx].__bad && tries++ < ims.length) nx = (nx + 1) % ims.length;
      if (nx === i) return;
      var im = ims[nx];
      busy = true;
      ready(im).then(function () {
        busy = false;
        if (!im.naturalWidth) { im.__bad = true; return; }   /* a photo that failed is left out from now on */
        var prev = ims[i];
        ims.forEach(function (x) { if (x !== prev) x.classList.remove('was'); });
        prev.classList.add('was'); prev.classList.remove('on'); ds[i].classList.remove('on');
        i = nx; im.classList.add('on'); ds[i].classList.add('on');
        clearTimeout(wasT); wasT = setTimeout(function () { prev.classList.remove('was'); }, 1700);
        ready(ims[(nx + 1) % ims.length]);    /* the one after loads now, so it is ready in its turn */
      });
    }
    function arm() { clearInterval(timer); timer = setInterval(function () { if (seen && !D.hidden) go(i + 1); }, rm() ? 9000 : 5200); }
    w.addEventListener('click', function () { go(i + 1); arm(); });
    w.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i + 1); arm(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (seen) ready(ims[1]); }, { threshold: 0.4 }).observe(w); else seen = true;
    arm();
  }

  /* ---------------- the Loox review row (the ff-loox-testimonials read, product-scoped, pinned first) ---------------- */
  var LOOX_API = 'https://storefront-api.loox.io/storefront/v1/store/';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg>';
  function getJSON(url) { return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('loox ' + r.status); return r.json(); }); }
  function photoUrl(u) { return String(u || '').replace(/_orig\.jpg$/i, '_mid.jpg'); }
  function mediaOf(r) {
    var out = { photo: '', video: null };
    (r && r.media || []).forEach(function (m) {
      if (!out.photo && m.type === 'photo' && m.url) out.photo = photoUrl(m.url);
      if (!out.video && m.type === 'video' && m.url) out.video = { src: m.url, poster: m.thumbnailUrl || '' };
    });
    if (!out.photo && out.video && out.video.poster) out.photo = out.video.poster;
    return out;
  }
  function buildReviews() {
    var box = $('#ffcLx'); if (!box) return;
    var c = {}; try { c = JSON.parse(($('[data-ffc-lx-config]', box) || {}).textContent || '{}'); } catch (e) { c = {}; }
    var allBtn = $('#ffcLxAll');
    wireSeeAll(allBtn, box);
    if (!c.store || !window.fetch) return;
    var base = LOOX_API + encodeURIComponent(c.store);
    var pinnedIds = String(c.pinned || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var skip = {};
    String(c.exclude || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (id) { skip[id] = 1; });
    $$('[data-ffc-review-id]').forEach(function (n) { skip[n.getAttribute('data-ffc-review-id')] = 1; });
    /* belt and braces: a review whose words are already quoted higher up never shows again */
    var quoted = $$('[data-ffc-review-id] blockquote').map(function (q) { return clean(q.textContent).toLowerCase().slice(0, 48); }).filter(Boolean);
    var ov = {}; (c.overrides || []).forEach(function (o) { if (o && o.id) ov[o.id] = o; });
    var ok = function (r) {
      if (!r || skip[r.id]) return false;
      var body = clean(r.body).toLowerCase();
      if (quoted.some(function (q) { return body.indexOf(q) > -1; })) return false;
      var o = ov[r.id], art = !!mediaOf(r).photo || !!(o && o.image);
      return art && (r.rating || 0) >= (+c.minRating || 1) && body.length >= (+c.minChars || 0);
    };
    var go = function () {
      var bottom = c.product ? getJSON(base + '/product-reviews/bottomline/' + encodeURIComponent(c.product)).catch(function () { return null; }) : Promise.resolve(null);
      var list = getJSON(base + '/product-reviews?sort=featured&limit=60&page=1' + (c.product ? '&product_id=' + encodeURIComponent(c.product) : ''));
      Promise.all([bottom, list]).then(function (res) {
        var bl = res[0], reviews = (res[1] && res[1].reviews) || [], by = {};
        reviews.forEach(function (r) { by[r.id] = r; });
        var missing = pinnedIds.filter(function (id) { return !by[id] && !skip[id]; });
        return Promise.all(missing.map(function (id) { return getJSON(base + '/product-reviews/' + encodeURIComponent(id)).then(function (x) { return x && x.review; }).catch(function () { return null; }); }))
          .then(function (extra) {
            extra.forEach(function (r) { if (r && r.id) by[r.id] = r; });
            var picked = [], seen = {};
            pinnedIds.forEach(function (id) { var r = by[id]; if (ok(r) && !seen[id]) { picked.push(r); seen[id] = 1; } });
            for (var i = 0; i < reviews.length && picked.length < (+c.count || 14); i++) { var r = reviews[i]; if (ok(r) && !seen[r.id]) { picked.push(r); seen[r.id] = 1; } }
            if (!picked.length) throw new Error('no reviews');
            renderReviews(box, picked.slice(0, +c.count || 14), ov, bl, allBtn);
          });
      }).catch(function (e) { if (window.console && console.warn) console.warn('FF collector reviews: ' + (e && e.message)); });
    };
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '1200px 0px' });
    io.observe(box);
  }
  function renderReviews(box, picked, ov, bl, allBtn) {
    var total = bl && bl.totalReviews, dist = bl && bl.ratingDistribution;
    if (total) {
      $$('[data-ffc-count]', box).forEach(function (n) { n.textContent = total; });
      if (allBtn) allBtn.textContent = String(allBtn.dataset.label || 'See all [count] reviews').replace('[count]', total);
    }
    if (bl && bl.averageRating) { var a = $('[data-ffc-avg]', box); if (a) a.textContent = (+bl.averageRating).toFixed(1); }
    var dl = $('#ffcLxDist');
    if (dl && dist && total) {
      dl.innerHTML = [5, 4, 3, 2, 1].map(function (n) { var k = +dist[n] || 0; return '<li><span>' + n + STAR + '</span><i style="--w:' + (k / total * 100).toFixed(1) + '%"></i><em>' + k + '</em></li>'; }).join('');
    } else if (dl) dl.remove();
    var tr = $('#ffcLxTrack');
    tr.innerHTML = picked.map(function (r) {
      var o = ov[r.id] || {}, m = mediaOf(r), art = (o.image || '').trim() || m.photo, who = (o.author || '').trim() || (r.reviewer && (r.reviewer.name || r.reviewer)) || 'Verified buyer';
      var stars = ''; for (var k = 0; k < 5; k++) stars += STAR;
      return '<figure class="ffc-lx-card" data-id="' + esc(r.id) + '"><span class="ffc-lx-img"><img src="' + esc(art) + '" alt="The portrait delivered to ' + esc(who) + '" width="640" height="640" loading="lazy" decoding="async" draggable="false">' +
        (m.video && !(o.image || '').trim() ? '<button type="button" class="ffc-lx-play" aria-label="Play the video review"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3.5v17l14-8.5z"/></svg></button>' : '') + '</span>' +
        '<span class="ffc-star-row" role="img" aria-label="' + (r.rating || 5) + ' stars">' + stars + '</span>' +
        '<blockquote class="ffc-lx-text is-clamped">' + esc(String(r.body || '').trim()) + '</blockquote><button type="button" class="ffc-lx-more" hidden>Read more</button>' +
        '<figcaption class="ffc-lx-by">' + esc(who) + (r.verified ? '<span class="ffc-lx-vf">' + CHECK + 'Verified</span>' : '') + '</figcaption></figure>';
    }).join('');
    var vids = {}; picked.forEach(function (r) { var m = mediaOf(r); if (m.video) vids[r.id] = m.video; });
    tr.addEventListener('click', function (e) {
      var more = e.target.closest('.ffc-lx-more');
      if (more) { var t = more.previousElementSibling, open = t.classList.toggle('is-clamped'); more.textContent = open ? 'Read more' : 'Read less'; return; }
      var play = e.target.closest('.ffc-lx-play');
      if (play) {
        var id = play.closest('.ffc-lx-card').getAttribute('data-id'), v = vids[id]; if (!v) return;
        var vid = D.createElement('video'); vid.src = v.src; vid.controls = true; vid.autoplay = true; vid.playsInline = true; vid.setAttribute('playsinline', ''); vid.setAttribute('controlslist', 'nodownload');
        if (v.poster) vid.poster = v.poster;
        play.parentNode.appendChild(vid); play.remove();
      }
    });
    tr.addEventListener('contextmenu', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });
    box.classList.add('is-live');
    /* a grid that reads downwards (Jan, 2026-10-21): two rows of four on a computer, three across on a tablet, a list on a
       phone; "Show more reviews" adds the next rows until every picked review shows */
    var nav = $('.ffc-lx-nav', box); if (nav) nav.remove();
    var cards = $$('.ffc-lx-card', tr), shownN = 0;
    var batch = function () { return matchMedia('(min-width:990px)').matches ? 8 : matchMedia('(min-width:600px)').matches ? 6 : 4; };
    var wrap = D.createElement('div'); wrap.className = 'ffc-lx-morewrap';
    wrap.innerHTML = '<button type="button" class="ffc-lx-showmore">Show more reviews</button>';
    tr.parentNode.insertBefore(wrap, tr.nextSibling);
    var moreBtn = $('button', wrap);
    var reveal = function (n) {
      shownN = Math.min(cards.length, n);
      cards.forEach(function (cd, i) { cd.hidden = i >= shownN; });
      wrap.hidden = shownN >= cards.length;
      requestAnimationFrame(clampMore);
    };
    moreBtn.addEventListener('click', function () {
      var first = cards[shownN];
      reveal(shownN + batch());
      if (first) first.classList.add('is-in');
    });
    var clampMore = function () { cards.forEach(function (cd) { if (cd.hidden) return; var t = $('.ffc-lx-text', cd), b = $('.ffc-lx-more', cd); if (t.classList.contains('is-clamped')) b.hidden = !(t.scrollHeight > t.clientHeight + 2); }); };
    var rz; addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { if (shownN < batch()) reveal(batch()); clampMore(); }, 200); });
    reveal(batch());
  }
  /* "See all reviews": the Loox app's own full list, in the apps section right below, closed until asked for.
     While it is open the curated row steps aside, so the same review never shows twice on screen. */
  function wireSeeAll(btn, box) {
    if (!btn) return;
    var sec = $('[id$="__1742452715438198e6"]');
    if (!sec) { btn.hidden = true; return; }
    btn.setAttribute('aria-controls', sec.id);
    var labelFor = function (open) { return open ? (btn.dataset.less || 'Hide the full list') : String(btn.dataset.label || 'See all [count] reviews').replace('[count]', ($('[data-ffc-count]', box) || {}).textContent || ''); };
    btn.addEventListener('click', function () {
      var open = !sec.classList.contains('ffc-open');
      sec.classList.toggle('ffc-open', open);
      var live = $('.ffc-lx-live', box); if (live) live.hidden = open;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = labelFor(open);
      if (open) { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
      else { var r = box.getBoundingClientRect(); if (r.top < 0) box.scrollIntoView({ block: 'start' }); }
    });
  }

  /* ---------------- the timeline (Jan, round 9) ---------------- */
  /* step 3: the change is circled by hand, then the note types itself; it repeats while the step is on screen */
  function armMarkup() {
    $$('.ffc-jr-steps .ffc-mk').forEach(function (mk) {
      var note = $('span', mk), svg = $('svg', mk), fig = mk.parentNode; if (!note || !svg) return;
      /* the notes and where each one sits (x, y, w, h in percent of the picture), from the step's settings (Jan, 2026-10-21) */
      var notes = [];
      try { notes = JSON.parse(mk.getAttribute('data-notes') || '[]') || []; } catch (e) { notes = []; }
      if (!notes.length) notes = [{ t: note.getAttribute('data-t') || note.textContent }];
      function place(n) {
        if (n.x == null) { svg.removeAttribute('style'); note.removeAttribute('style'); return; }
        svg.style.left = n.x + '%'; svg.style.top = n.y + '%'; svg.style.width = n.w + '%'; svg.style.height = n.h + '%';
        /* the note sits under its loop, or above it near the bottom, always inside the picture */
        var W = fig.clientWidth || 1, H = fig.clientHeight || 1, nw = note.offsetWidth / W * 100, nh = note.offsetHeight / H * 100;
        var below = n.y + n.h + 2 + nh <= 96, ty = below ? n.y + n.h + 2 : Math.max(3, n.y - nh - 2);
        note.style.left = clamp(n.x + n.w / 2 - nw / 2, 3, 97 - nw) + '%'; note.style.top = ty + '%';
      }
      if (rm() || !('IntersectionObserver' in window)) { note.textContent = notes[0].t; place(notes[0]); return; }
      var timers = [], running = false, seen = false, k = 0;
      mk.classList.add('is-armed'); note.innerHTML = '<b></b><i class="ffc-mk-caret"></i>';
      var bb = $('b', note);
      function at(ms, f) { timers.push(setTimeout(f, ms)); }
      function cycle() {
        running = true; timers.forEach(clearTimeout); timers = [];
        var n = notes[k % notes.length], txt = n.t; k++;
        mk.classList.remove('is-draw', 'is-type', 'is-out', 'is-done');
        bb.textContent = txt; place(n); bb.textContent = ''; void mk.offsetWidth;
        at(250, function () { mk.classList.add('is-draw'); });
        at(1050, function () { mk.classList.add('is-type'); });
        for (var i = 1; i <= txt.length; i++) (function (m) { at(1200 + m * 55, function () { bb.textContent = txt.slice(0, m); }); })(i);
        var end = 1200 + txt.length * 55;
        at(end + 500, function () { mk.classList.add('is-done'); });
        at(end + 2300, function () { mk.classList.add('is-out'); });
        at(end + 2850, function () { if (seen) cycle(); else running = false; });
      }
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (seen && !running) cycle(); }, { threshold: 0.6 }).observe(fig);
    });
  }
  /* step 1: the wide picture pans across once at a steady pace, and as it nears the end the next landscape fades in over
     it and pans on, through every picture and round again (Jan, 2026-10-21: "when it reaches the end of one of the
     images, make it smoothly fade into the next landscape so it keeps going and loop"). Both layers move at the same
     speed through the fade, so the motion never stops. One clock drives them and only runs while the step is on screen
     and the tab is showing; each picture is loaded and decoded on the hidden layer before its turn, and the fade waits
     for it. With reduced motion the first picture stays still, as before. */
  function armPanCycle() {
    $$('.ffc-jr-fig > img.ffc-pan[data-ffc-more]').forEach(function (first) {
      var fig = first.parentNode, PAN = 22000, FADE = 2200;
      var list = [first.getAttribute('src')].concat(first.getAttribute('data-ffc-more').split('|').map(function (u) { return u.trim() ? widthUrl(u.trim(), 1600) : ''; }).filter(Boolean));
      if (list.length < 2 || rm() || !('IntersectionObserver' in window)) return;
      /* it takes over from the CSS pan where that has got to, so the picture never jumps */
      var m = (getComputedStyle(first).transform || '').match(/matrix\(([^)]+)\)/), tx = m ? parseFloat(m[1].split(',')[4]) || 0 : 0;
      var lead = clamp(-tx / ((first.offsetWidth || 1) * 0.5), 0, 1) * PAN;
      fig.classList.add('is-cycle'); first.style.setProperty('--pan-x', (-50 * lead / PAN).toFixed(3) + '%');
      var back = D.createElement('img'); back.className = 'ffc-pan'; back.alt = ''; back.setAttribute('aria-hidden', 'true'); back.decoding = 'async'; back.draggable = false;
      back.style.setProperty('--pan-o', '0'); fig.insertBefore(back, first.nextSibling);
      var layers = [first, back], cur = 0, nextI = 1, ready = false, asked = false, start = -lead, clock = 0, last = 0, raf = 0, seen = false, fadeAt = -1, fails = 0;
      /* the next picture goes on the hidden layer and is decoded there before it may fade in */
      function load(i) {
        var el = layers[1 - cur], my = list[i]; nextI = i; ready = false;
        var done = function () { if (el.getAttribute('src') === my) { ready = true; fails = 0; } };
        el.src = my;
        /* a picture that will not load is skipped; with none loading (offline) the last one simply stays */
        if (el.decode) el.decode().then(done, function () { if (el.getAttribute('src') === my && ++fails < list.length) load((i + 1) % list.length); });
        else if (el.complete) done(); else el.onload = done;
      }
      /* through --pan-x and --pan-o: the page's scroll reveal pins images' transform and opacity with !important, and the
         rule in ff-collector.css that reads these wins over it */
      function pos(el, t) { el.style.setProperty('--pan-x', (-50 * clamp(t / PAN, 0, 1)).toFixed(3) + '%'); }
      function frame(now) {
        raf = 0;
        if (!seen || D.hidden) { last = 0; return; }
        if (last) clock += Math.min(64, now - last);
        last = now;
        var a = layers[cur], b = layers[1 - cur];
        pos(a, clock - start);
        if (fadeAt < 0 && ready && clock - start >= PAN - FADE) { fadeAt = clock; b.style.zIndex = '2'; a.style.zIndex = '1'; }
        if (fadeAt >= 0) {
          var f = clamp((clock - fadeAt) / FADE, 0, 1);
          b.style.setProperty('--pan-o', f.toFixed(3)); pos(b, clock - fadeAt);
          if (f >= 1) { a.style.setProperty('--pan-o', '0'); cur = 1 - cur; start = fadeAt; fadeAt = -1; load((nextI + 1) % list.length); }
        }
        raf = requestAnimationFrame(frame);
      }
      function go() { if (!raf && seen && !D.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (seen && !asked) { asked = true; load(1); } go(); }, { rootMargin: '200px 0px' }).observe(fig);
      D.addEventListener('visibilitychange', go);
    });
  }
  /* step 4: Jan's signature traced once when the step comes into view */
  function armJourneySign() {
    $$('.ffc-jr-sign [data-ffc-sign]').forEach(function (ink) {
      ink.innerHTML = SIG(); ink.classList.add('ffc-ink-sig');
      var host = ink.parentNode, no = $('[data-ffc-no]', host), eds = $$('[data-ffc-ed]', host.closest('li') || host);
      if (rm() || !('IntersectionObserver' in window)) return;
      host.dataset.rv = '0';
      var seen = false, run = 0, timers = [];
      function at(ms, f) { timers.push(setTimeout(f, ms)); }
      /* one run from No. 1 to 1000 that never stops (Jan, 2026-10-21: "continuous instead of pausing at each edition"):
         quick through the Founder's Edition, slower through the five editions of 50 so each name reads, quick again
         through the Unlimited Edition and easing into 1000; it holds there, rests, and starts over */
      /* the number turns like a counter's wheels (Jan, 2026-10-21: "can the number going up feel smoother as well? its
         jumping a bit fast"): each digit has a slot as wide as the widest digit, so the line never shifts, and slides up
         into the next. The ones wheel turns with the count; each wheel above it turns over as the one below runs out
         (the tens over the last 2.5 numbers, the hundreds and thousands over the last 8), so no number flickers in */
      var wheels = [], od = null, capEl = null, capTxt = null;
      if (no) {
        no.innerHTML = 'No. <i class="ffc-od"></i><span></span>';
        od = $('.ffc-od', no); capEl = $('span', no);
        /* the slot: the widest digit in the card's own font, measured again once the font has loaded */
        var measure = function () {
          var probe = D.createElement('i'); probe.className = 'ffc-od-m'; od.appendChild(probe);
          var wmax = 0; for (var dg = 0; dg <= 9; dg++) { probe.textContent = dg; wmax = Math.max(wmax, probe.getBoundingClientRect().width); }
          probe.remove(); if (wmax) no.style.setProperty('--od-w', Math.ceil(wmax + 2) + 'px');
        };
        measure(); if (D.fonts && D.fonts.ready) D.fonts.ready.then(measure);
      }
      function wheel(grow) {
        var el = D.createElement('i'); el.className = 'ffc-od-d' + (grow ? ' is-in' : ''); el.innerHTML = '<i></i><i></i>';
        od.insertBefore(el, od.firstChild);
        var w = { el: el, a: el.firstChild, b: el.lastChild, v: -1, f: -1 }; wheels.push(w);
        /* a new leading digit (at 10, 100 and 1000) opens its slot instead of pushing the line over */
        if (grow) requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-in'); }); });
        return w;
      }
      function show(x) {
        var n = Math.floor(x), e = editionOf(n) || EDITIONS[EDITIONS.length - 1];
        if (od) {
          var len = String(n).length;
          while (wheels.length > len) wheels.pop().el.remove();
          while (wheels.length < len) wheel(wheels.length > 0 && n > 1);
          wheels.forEach(function (w, k) {
            var p = Math.pow(10, k), v = Math.floor(n / p) % 10, f;
            if (!k) f = x - n;
            else { var wd = k === 1 ? 2.5 : 8; f = clamp((x % p - (p - wd)) / wd, 0, 1); }
            f = Math.round(f * 100) / 100;
            if (v !== w.v) { w.v = v; w.a.textContent = v; w.b.textContent = (v + 1) % 10; }
            if (f !== w.f) { w.f = f; w.a.style.transform = f ? 'translateY(' + (-f * 100) + '%)' : ''; w.b.style.transform = 'translateY(' + ((1 - f) * 100) + '%)'; }
          });
          var cap = capOf(e) ? '/' + capOf(e) : '';
          if (cap !== capTxt) { capTxt = cap; capEl.textContent = cap; }
        }
        /* the edition inside the picture and the one under it on a phone */
        if (eds.length && eds[0].textContent !== e[1]) eds.forEach(function (ed) { ed.textContent = e[1]; ed.classList.remove('is-new'); void ed.offsetWidth; ed.classList.add('is-new'); });
      }
      var TOP = 1000, OPEN = EDITIONS[EDITIONS.length - 2][0];
      /* numbers a second at n (Jan, 2026-10-21: "slow it down a bit", about 11 s from 1 to 1000): each change of pace
         blends over 30 numbers, so the count only ever speeds up or slows */
      function pace(n) {
        var sm = function (a) { var x = clamp((n - a + 15) / 30, 0, 1); return x * x * (3 - 2 * x); };
        var v = 120 + (48 - 120) * sm(FOUNDING);
        v += (170 - v) * sm(OPEN);
        return v * Math.max(0.12, Math.min(1, (TOP - n) / 160));
      }
      function count() {
        var my = ++run, n = 1, last = performance.now();
        show(1);
        (function tick(now) {
          if (my !== run) return;
          /* a slow or hidden frame slows the count instead of jumping it */
          var dt = Math.min(0.05, Math.max(0, now - last) / 1000); last = now;
          n = Math.min(TOP, n + pace(n) * dt); show(n);
          if (n < TOP) { requestAnimationFrame(tick); return; }
          at(1400, function () { if (my !== run) return; host.classList.add('is-rest'); });
          at(2000, function () { if (my !== run) return; host.classList.remove('is-rest'); if (seen) count(); });
        })(last);
      }
      show(1);
      var signed = false;
      new IntersectionObserver(function (es) {
        seen = es[0].isIntersecting;
        if (!seen) { run++; timers.forEach(clearTimeout); timers = []; host.classList.remove('is-rest'); return; }
        if (!signed) { signed = true; sigPlay(host, 200, function () { if (seen) count(); }); } else count();
      }, { threshold: 0.6 }).observe(host);
    });
  }

  /* ---------------- videos: load and play only on screen, never under reduced motion ---------------- */
  function wireVideos() {
    var vids = $$('.ffc-root video[data-ffc-src]'); if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (v._ffcReel) { v._ffcReel(e.isIntersecting && !rm()); return; }
        if (e.isIntersecting) {
          if (rm()) return;
          if (!v.getAttribute('src')) { v.src = v.getAttribute('data-ffc-src'); v.preload = 'auto'; }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); armReel(v); io.observe(v); });
  }

  /* A video with more films in data-ffc-reel (the Living Motion tile, Jan 2026-10-27) plays them in turn, then the
     first again. A second video waits under the first and starts about a second before the first ends; it fades in
     only once its own first frame is drawn, while the first holds its last frame, so a slow start never shows a gap.
     Then the two swap. Only the next film loads ahead, and only while the tile is on screen. */
  function armReel(v) {
    var list = [v.getAttribute('data-ffc-src')].concat((v.getAttribute('data-ffc-reel') || '').split(/\s+/)).filter(Boolean);
    if (list.length < 2) return;
    var LEAD = 1.1, FADE = 800;
    var w = v.cloneNode(false);
    ['poster', 'data-ffc-src', 'data-ffc-reel', 'aria-label'].forEach(function (a) { w.removeAttribute(a); });
    w.setAttribute('aria-hidden', 'true');
    v.loop = w.loop = false; v.removeAttribute('loop'); w.removeAttribute('loop');
    w.muted = true;
    v.classList.add('ffc-reel', 'on'); w.classList.add('ffc-reel');
    v.parentNode.insertBefore(w, v.nextSibling);
    var cur = v, nxt = w, at = 0, seen = false, turn = 0, fading = false;
    function queue() { nxt.src = list[(at + 1) % list.length]; nxt.preload = 'auto'; }
    function framed(el, go) {
      if (el.requestVideoFrameCallback) el.requestVideoFrameCallback(function () { go(); });
      else el.addEventListener('playing', function h() { el.removeEventListener('playing', h); go(); });
    }
    function next() {
      if (fading || !seen) return;
      fading = true; var my = ++turn;
      framed(nxt, function () {
        if (my !== turn) return;
        nxt.classList.add('on', 'top');
        setTimeout(function () {
          if (my !== turn) return;
          cur.pause(); cur.classList.remove('on'); nxt.classList.remove('top');
          var was = cur; cur = nxt; nxt = was; at = (at + 1) % list.length; fading = false;
          queue();
        }, FADE + 60);
      });
      var p = nxt.play(); if (p && p.catch) p.catch(function () { if (my === turn) { turn++; fading = false; } });
    }
    [v, w].forEach(function (el) {
      el.addEventListener('timeupdate', function () {
        if (el === cur && el.duration && el.duration - el.currentTime <= LEAD) next();
      });
      el.addEventListener('ended', function () { if (el === cur) next(); });
      el.addEventListener('error', function () {
        if (el !== nxt || !el.getAttribute('src')) return;
        /* a film that will not load drops out of the turn; with one left, it loops on its own */
        var k = (at + 1) % list.length; list.splice(k, 1); if (k < at) at--; turn++; fading = false;
        if (list.length < 2) { cur.loop = true; if (seen && cur.ended) cur.play(); } else queue();
      });
    });
    v._ffcReel = function (on) {
      seen = on;
      if (!on) { cur.pause(); nxt.pause(); return; }
      /* the next film waits for the first to play, so the first has the line to itself */
      if (!cur.getAttribute('src')) {
        cur.src = list[0]; cur.preload = 'auto';
        cur.addEventListener('playing', function h() { cur.removeEventListener('playing', h); if (!nxt.getAttribute('src')) queue(); });
      }
      if (cur.ended) next();
      else { var p = cur.play(); if (p && p.catch) p.catch(function () {}); }
      if (fading) { var q = nxt.play(); if (q && q.catch) q.catch(function () {}); }
    };
  }

  /* ---------------- boot ---------------- */
  function fontsDone() { FONTS_READY = true; CARDS.forEach(function (c) { c.fit(); c.fitText(); }); }
  function boot() {
    watchHero();
    watchRows();
    buildReviews();
    armCollection();
    wireVideos();
    $$('[data-ffc-uwall]').forEach(buildUWall);
    armPanCycle();
    buildHallWall();
    /* the cards wait for the first picture to paint, so the signature and fonts never compete with it */
    var cards = function () {
      buildGallery();
      buildReceive();
      buildMine();
      buildStage();
      armSign();
      armMarkup();
      armJourneySign();
      $$('[data-ffc-vtt]').forEach(buildVtt);
      if (D.fonts && D.fonts.ready) D.fonts.ready.then(fontsDone); else setTimeout(fontsDone, 600);
      onIdle(hall, 2500);
    };
    if (D.readyState === 'complete') onIdle(cards, 800);
    else addEventListener('load', function () { onIdle(cards, 800); });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
